import { useEffect, useRef, useState } from 'react';
import { getCommonInfoImg, getPAIAB010, getPAIAB010Info, postPAIAB010, putPAIAB010 } from '../../../services/Api';
import Dropdown from '../../../shared/components/Dropdown';
import SideNav from '../../../shared/components/SideNav';

import { ko } from 'date-fns/locale/ko';
import { decodeHTML } from 'entities';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Checkbox from '../../../shared/components/Checkbox';
import CustomInputDatePicker from '../../../shared/components/CustomInputDatePicker';
import ImageCheckFallback from '../../../shared/components/ImageCheckFallback';
import ImageCropper from '../../../shared/components/ImageCropper';
import { MESSAGE } from '../../../shared/constants/app';
import { decodeHTMLEntities, decodeToken, handleFocus } from '../../../utils';

registerLocale('ko', ko);

// Các mã 군/구 không cho người dùng chọn
const excludedGuCodes = ['305', '307', '310'];

const PAIAB010 = () => {
    const { id } = useParams();
    const [resumeRegionSi, setResumeRegionSi] = useState([]);
    const [resumeRegionGu, setResumeRegionGu] = useState({});
    const [selectedSi1, setSelectedSi1] = useState(null);
    const [selectedSi2, setSelectedSi2] = useState(null);
    const [selectedSi3, setSelectedSi3] = useState(null);

    const [fileAvatar, setFileAvatar] = useState(null);
    const [deletedOldAvatar, setDeletedOldAvatar] = useState('N');
    const [previewUrl, setPreviewUrl] = useState(null);
    const [showCropper, setShowCropper] = useState(false);
    const [originalFileName, setOriginalFileName] = useState('');
    const fileInputRef = useRef(null);
    const navigate = useNavigate();
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const memberID = decode.memberID;

    const normalizeMonth = (month) => {
        if (!month) return '';
        return String(month).padStart(2, '0');
    };

    const parseYearMonth = (value) => {
        if (!value) return null;
        const date = moment(value, 'YYYY-MM', true);
        return date.isValid() ? date.toDate() : null;
    };

    const [formResumeSchoolInfo, setFormResumeSchoolInfo] = useState({
        yearStart: ['', '', ''],
        monthStart: ['', '', ''],
        yearEnd: ['', '', ''],
        monthEnd: ['', '', ''],
        schoolName: ['', '', ''],
        grade: ['', '', ''],
        major: ['', '', ''],
        status: ['', '', ''],
        gpa: ['', '', ''],
        gpaScale: ['', '4.0', '4.0'],
    });

    const [careerList, setCareerList] = useState([
        {
            careerYearMonthStart1: '',
            careerYearMonthEnd1: '',
            businessName1: '',
            careerSi1: '',
            position1: '',
            respon1: '',
            reasonsLeave1: '',
            working1: 'N',
        },
    ]);

    const [licenseList, setLicenseList] = useState([
        {
            licenseType1: '',
            licenseName1: '',
            licenseNumber1: '',
            licensePlace1: '',
            licenseYearMonth1: '',
        },
    ]);

    const [activeResumeList, setActiveResumeList] = useState([
        {
            type1: '',
            place1: '',
            activeYearMonthStart1: '',
            activeYearMonthEnd1: '',
            content1: '',
        },
    ]);

    const [payload, setPayload] = useState({
        resumeLvl: 'Y',
        resumeGrade: '001',
        resumeCareer: '001',
        proposeSMS: 'Y',
        contactMethod: 'pps',
        resumeCareerYear: '',
        resumePayEtc: '',
        resumeActiveInfo: '',
        resumeContent: '',
        homeUrl: '',
        resumeCareerInfo: '',
        resumeLicenseInfo: '',
        resumeLicenseYn: 'N',
        resumeActiveYn: 'N',
        resumeRegionSi2: '',
        resumeRegionGu2: '',
        resumeRegionSi3: '',
        resumeRegionGu3: '',
        resumeSchoolEtc: '',
    });


    const parseResumeCareerInfo = (dataString, careerKeys, dataResumeRegionSi) => {
        const dataSections = (dataString || '').split('|');

        const startYears = dataSections[0]?.split('###') || [];
        const startMonths = dataSections[1]?.split('###') || [];
        const endYears = dataSections[2]?.split('###') || [];
        const endMonths = dataSections[3]?.split('###') || [];
        const businessNames = dataSections[4]?.split('###') || [];
        const regions = dataSections[5]?.split('###') || [];
        const positions = dataSections[6]?.split('###') || [];
        const responsibilities = dataSections[7]?.split('###') || [];
        const leaveReasons = dataSections[8]?.split('###') || [];
        const workingStatus = dataSections[9]?.split('###') || [];

        const totalEntries = startYears.length;

        const positionMap = [
            { value: '팀장', option: '팀장' },
            { value: '실장', option: '실장' },
            { value: '스탭', option: '스탭' },
            { value: '기타', option: '기타' },
        ];

        const sortedIndices = Array.from({ length: totalEntries }, (_, i) => i).sort((a, b) => {
            const yearA = parseInt(startYears[a]?.trim()) || 0;
            const monthA = parseInt(startMonths[a]?.trim()) || 0;
            const yearB = parseInt(startYears[b]?.trim()) || 0;
            const monthB = parseInt(startMonths[b]?.trim()) || 0;

            if (yearB !== yearA) return yearB - yearA;
            return monthB - monthA;
        });

        const careerList = [];

        for (let order = 0; order < totalEntries; order++) {
            const i = sortedIndices[order];

            const careerSiName = regions[i]?.trim() || '';
            const positionName = positions[i]?.trim() || '';

            const matchedRegion = dataResumeRegionSi.find(
                (item) => item.codeName === careerSiName || item.code === careerSiName,
            );

            const matchedPosition = positionMap.find((item) => item.value === positionName);

            const entry = {
                [`careerYearMonthStart${order + 1}`]: buildYearMonth(startYears[i], startMonths[i]),
                [`careerYearMonthEnd${order + 1}`]: buildYearMonth(endYears[i], endMonths[i]),

                [`businessName${order + 1}`]: businessNames[i]?.trim() || '',
                [`careerSi${order + 1}`]: matchedRegion ? matchedRegion.codeName : '',
                [`position${order + 1}`]: matchedPosition ? matchedPosition.value : '',
                [`respon${order + 1}`]: decodeHTML(decodeHTMLEntities(responsibilities[i])) || '',
                [`reasonsLeave${order + 1}`]: decodeHTML(decodeHTMLEntities(leaveReasons[i])) || '',
                [`working${order + 1}`]: workingStatus[i]?.trim() || 'N',
            };

            careerList.push(entry);
        }

        return careerList;
    };

    const buildYearMonth = (year, month) => {
        const m = parseInt(month, 10);
        if (!year || !m || m < 1 || m > 12) return '';
        return `${year}-${m.toString().padStart(2, '0')}`;
    };


    const parseResumeLicenseInfo = (dataString) => {
        const dataSections = dataString.split('|');

        const licenseYears = dataSections[0]?.split('###') || [];
        const licenseMonths = dataSections[1]?.split('###') || [];
        const names = dataSections[2]?.split('###') || [];
        const places = dataSections[3]?.split('###') || [];
        const types = dataSections[4]?.split('###') || [];
        const numbers = dataSections[5]?.split('###') || [];

        const totalEntries = licenseYears.length;
        const licenseList = [];

        for (let i = 0; i < totalEntries; i++) {
            const entry = {
                [`licenseYearMonth${i + 1}`]: buildYearMonth(licenseYears[i], licenseMonths[i]),
                [`licenseName${i + 1}`]: names[i]?.trim() || '',
                [`licensePlace${i + 1}`]: places[i]?.trim() || '',
                [`licenseType${i + 1}`]: types[i]?.trim() || '',
                [`licenseNumber${i + 1}`]: numbers[i]?.trim() || '',
            };
            licenseList.push(entry);
        }

        return licenseList;
    };

    const parseActiveInfo = (dataString) => {
        const dataSections = dataString.split('|');

        const startYears = dataSections[0]?.split('###') || [];
        const startMonths = dataSections[1]?.split('###') || [];
        const endYears = dataSections[2]?.split('###') || [];
        const endMonths = dataSections[3]?.split('###') || [];
        const places = dataSections[4]?.split('###') || [];
        const contents = dataSections[5]?.split('###') || [];
        const types = dataSections[6]?.split('###') || [];

        const totalEntries = startYears.length;
        const activeList = [];

        for (let i = 0; i < totalEntries; i++) {
            const entry = {
                [`activeYearMonthStart${i + 1}`]: buildYearMonth(startYears[i], startMonths[i]),
                [`activeYearMonthEnd${i + 1}`]: buildYearMonth(endYears[i], endMonths[i]),
                [`place${i + 1}`]: places[i]?.trim() || '',
                [`content${i + 1}`]: decodeHTML(decodeHTMLEntities(contents[i])) || '',
                [`type${i + 1}`]: types[i]?.trim() || '',
            };
            activeList.push(entry);
        }

        return activeList;
    };

    useEffect(() => {
        getPAIAB010Info()
            .then(({ data }) => {
                const dataResumeRegionSi = data.resumeRegionSi;
                setResumeRegionSi(data.resumeRegionSi);
                setResumeRegionGu(data.resumeRegionGu);
                if (!id) {
                    setSelectedSi1(null);
                    setSelectedSi2(null);
                    setSelectedSi3(null);
                    setFileAvatar(null);
                    setPreviewUrl(null);
                    setShowCropper(false);
                    setOriginalFileName('');
                    setFormResumeSchoolInfo({
                        yearStart: ['', '', ''],
                        monthStart: ['', '', ''],
                        yearEnd: ['', '', ''],
                        monthEnd: ['', '', ''],
                        schoolName: ['', '', ''],
                        grade: ['', '', ''],
                        major: ['', '', ''],
                        status: ['', '', ''],
                        gpa: ['', '', ''],
                        gpaScale: ['', '4.0', '4.0'],
                    });
                    setCareerList([
                        {
                            careerYearMonthStart1: '',
                            careerYearMonthEnd1: '',
                            businessName1: '',
                            careerSi1: '',
                            position1: '',
                            respon1: '',
                            reasonsLeave1: '',
                            working1: 'N',
                        },
                    ]);
                    setLicenseList([
                        {
                            licenseType1: '',
                            licenseName1: '',
                            licenseNumber1: '',
                            licensePlace1: '',
                            licenseYearMonth1: '',
                        },
                    ]);
                    setActiveResumeList([
                        {
                            type1: '',
                            place1: '',
                            activeYearMonthStart1: '',
                            activeYearMonthEnd1: '',
                            content1: '',
                        },
                    ]);
                    setPayload((prev) => ({
                        ...prev,
                        resumeLvl: 'Y',
                        resumeGrade: '001',
                        resumeCareer: '001',
                        resumeCareerYear: '',
                        resumePayEtc: '',
                        resumeActiveInfo: '',
                        resumeContent: '',
                        homeUrl: '',
                        resumeCareerInfo: '',
                        resumeLicenseInfo: '',
                        resumeLicenseYn: 'N',
                        resumeActiveYn: 'N',
                    }));

                    getCommonInfoImg()
                        .then(({ data }) => {
                            setPayload((prev) => ({
                                ...prev,
                                nameKor: data.nameKor,
                                mobileNo: formatPhoneNumber(data.mobileNo),
                                email: data.email,
                                resumeLogo: data.avatar,
                            }));

                            setPreviewUrl(data.avatar);
                        })
                        .catch((error) => console.log(error));
                    return;
                }
                if (id) {
                    getPAIAB010(id)
                        .then(({ data }) => {
                            setPayload((prev) => ({
                                ...prev,
                                ...data,
                            }));

                            if (data.resumeLogo) {
                                setPreviewUrl(data.resumeLogo);
                            }

                            const careerKeys = {
                                startYear: 'careerYearMonthStart',
                                endYear: 'careerYearMonthEnd',
                                businessNames: 'businessName',
                                careerSiNames: 'careerSi',
                                positions: 'position',
                                responsibilities: 'respon',
                                reasonsLeave: 'reasonsLeave',
                                workings: 'working',
                            };

                            const licenseKeys = {
                                licenseYears: 'licenseYearMonth',
                                licenseNames: 'licenseName',
                                licensePlaces: 'licensePlace',
                                licenseTypes: 'licenseType',
                                licenseNumbers: 'licenseNumber',
                            };

                            const activeKeys = {
                                startYear: 'activeYearMonthStart',
                                endYear: 'activeYearMonthEnd',
                                places: 'place',
                                contents: 'content',
                                types: 'type',
                            };
                            setCareerList(parseResumeCareerInfo(data.resumeCareerInfo, careerKeys, dataResumeRegionSi));
                            setLicenseList(parseResumeLicenseInfo(data.resumeLicenseInfo, licenseKeys));
                            setActiveResumeList(parseActiveInfo(data.resumeActiveInfo, activeKeys));
                        })
                        .catch((error) => console.log(error));
                }
            })
            .catch((error) => console.log(error));

        // eslint-disable-next-line
    }, []);

    const formatPhoneNumber = (number) => {
        if (/^\d{3}-\d{4}-\d{4}$/.test(number)) {
            return number;
        }

        const cleaned = number?.replace(/\D/g, '');
        if (cleaned.length === 11) {
            return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
        }
        return number;
    };

    const getOptions = (name, selectedValue = null, currentGuValue = '') => {
        const options = {
            Grade1: [
                { value: '전문대학 1년', option: '전문대학 1년' },
                { value: '전문대학 2년', option: '전문대학 2년' },
                { value: '전문대학 3년', option: '전문대학 3년' },
                { value: '전문대학', option: '전문대학' },
                { value: '대학교 1년', option: '대학교 1년' },
                { value: '대학교 2년', option: '대학교 2년' },
                { value: '대학교 3년', option: '대학교 3년' },
                { value: '대학교 4년', option: '대학교 4년' },
                { value: '대학교(학사)', option: '대학교(학사)' },
            ],

            Grade2: [
                { value: '대학원 재중', option: '대학원 재중' },
                { value: '대학원 (석사)', option: '대학원 (석사)' },
                { value: '대학원 (박사)', option: '대학원 (박사)' },
            ],

            ResumeRegionSi: resumeRegionSi.map((item) => ({
                id: 'resumeRegionSi_' + item.code,
                option: item.codeName,
                value: item.code,
            })),

            ResumeRegionGu:
                selectedValue && resumeRegionGu[selectedValue]
                    ? resumeRegionGu[selectedValue]
                        // Không cho chọn các mã 군/구: 305, 307, 310.
                        // Nếu đã lưu sẵn một trong các mã đó thì vẫn giữ lại option (ẩn khỏi list)
                        // để selectbox hiển thị đúng text đã lưu.
                        .filter(
                            (item) =>
                                !excludedGuCodes.includes(String(item.code)) ||
                                String(currentGuValue) === String(item.code),
                        )
                        .map((item) => ({
                            id: 'resumeRegionGu_' + item.code,
                            option: item.codeName,
                            value: item.code,
                            hidden: excludedGuCodes.includes(String(item.code)),
                        }))
                    : [],
        };

        return options[name];
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setPayload({
            ...payload,
            [name]: value,
        });
    };

    const handleCheckBox = (e) => {
        const { name, value, checked, type } = e.target;

        if (type === 'checkbox') {
            setPayload((prev) => {
                const currentValues = prev[name] ? prev[name].split(',') : [];
                let updatedValues;

                if (checked) {
                    updatedValues = [...new Set([...currentValues, value])].sort();
                } else {
                    updatedValues = currentValues.filter((item) => item !== value);
                }

                return {
                    ...prev,
                    [name]: updatedValues.join(','),
                };
            });
        }

        if (type === 'radio') {
            setPayload((prev) => ({
                ...prev,
                [name]: checked ? value : '',
            }));
        }
    };

    const handleSelectSi = (selectedValue, name) => {
        setPayload({ ...payload, [name]: selectedValue });
        if (name === 'resumeRegionSi1') setSelectedSi1(selectedValue);
        if (name === 'resumeRegionSi2') setSelectedSi2(selectedValue);
        if (name === 'resumeRegionSi3') setSelectedSi3(selectedValue);
    };

    const handleChangeDropdown = (selectedValue, name) => {
        setPayload({ ...payload, [name]: selectedValue });
    };

    const handleChangeSchoolInfo = (selectedValue, name) => {
        const [field, index] = name.match(/([a-zA-Z]+)(\d+)/).slice(1, 3);

        setFormResumeSchoolInfo((prev) => {
            const updatedField = [...prev[field]];
            updatedField[index - 1] = selectedValue;

            return {
                ...prev,
                [field]: updatedField,
            };
        });
    };

    const handleInputChangeSchoolInfo = (e) => {
        const { name, value } = e.target;
        const match = name.match(/([a-zA-Z]+)(\d+)/);

        if (!match) return;

        const [, field, index] = match;
        const fieldIndex = parseInt(index, 10) - 1;

        setFormResumeSchoolInfo((prev) => {
            const updatedForm = { ...prev };

            if (!Array.isArray(prev[field])) return prev;
            const updatedField = [...prev[field]];
            updatedField[fieldIndex] = value;
            updatedForm[field] = updatedField;

            return updatedForm;
        });
    };

    const handleDateChangeSchoolInfo = (value, name) => {
        const match = name.match(/([a-zA-Z]+)(\d+)/);

        if (!match) return;

        const [, field, index] = match;
        const fieldIndex = parseInt(index, 10) - 1;
        setFormResumeSchoolInfo((prev) => {
            const updatedForm = { ...prev };

            if (field.startsWith('yearMonthStart') || field.startsWith('yearMonthEnd')) {
                let [year, month] = moment(value).format('YYYY-MM').split('-');
                if (field.startsWith('yearMonthStart')) {
                    updatedForm.yearStart[fieldIndex] = year || '';
                    updatedForm.monthStart[fieldIndex] = month || '';
                } else {
                    updatedForm.yearEnd[fieldIndex] = year || '';
                    updatedForm.monthEnd[fieldIndex] = month || '';
                }
            }

            return updatedForm;
        });
    };

    useEffect(() => {
        if (payload.resumeSchoolInfo) {
            const fields = payload.resumeSchoolInfo.split('|').map((field) => field.split(','));
            const updatedForm = {
                yearStart: fields[0] || ['', '', ''],
                monthStart: (fields[1] || ['', '', '']).map(m => normalizeMonth(m)),
                yearEnd: fields[2] || ['', '', ''],
                monthEnd: (fields[3] || ['', '', '']).map(m => normalizeMonth(m)),
                schoolName: fields[4] || ['', '', ''],
                grade: fields[5] || ['', '', ''],
                major: fields[6] || ['', '', ''],
                status: fields[7] || ['', '', ''],
                gpa: fields[8] || ['', '', ''],
                gpaScale: fields[9] || ['', '', ''],
            };

            setFormResumeSchoolInfo((prev) =>
                JSON.stringify(prev) !== JSON.stringify(updatedForm) ? updatedForm : prev,
            );
        }
    }, [payload.resumeSchoolInfo]);

    const handleAddCareer = () => {
        setCareerList((prev) => {
            const nextIndex = prev.length + 1;
            const newCareer = {
                [`careerYearMonthStart${nextIndex}`]: '',
                [`careerYearMonthEnd${nextIndex}`]: '',
                [`businessName${nextIndex}`]: '',
                [`careerSi${nextIndex}`]: '',
                [`position${nextIndex}`]: '',
                [`respon${nextIndex}`]: '',
                [`reasonsLeave${nextIndex}`]: '',
                [`working${nextIndex}`]: 'N',
            };

            return [...prev, newCareer];
        });
    };

    const handleAddLicense = () => {
        setLicenseList((prev) => {
            const nextIndex = prev.length + 1;
            const newLicense = {
                [`licenseType${nextIndex}`]: '',
                [`licenseName${nextIndex}`]: '',
                [`licenseNumber${nextIndex}`]: '',
                [`licensePlace${nextIndex}`]: '',
                [`licenseYearMonth${nextIndex}`]: '',
            };

            return [...prev, newLicense];
        });
    };

    const handleAddActive = () => {
        setActiveResumeList((prev) => {
            const nextIndex = prev.length + 1;
            const newActive = {
                [`type${nextIndex}`]: '',
                [`place${nextIndex}`]: '',
                [`activeYearMonthStart${nextIndex}`]: '',
                [`activeYearMonthEnd${nextIndex}`]: '',
                [`content${nextIndex}`]: '',
            };

            return [...prev, newActive];
        });
    };

    const handleDeleteItem = (index, setList) => {
        setList((prev) => {
            const filtered = prev.filter((_, i) => i !== index);

            return filtered.map((item, newIndex) => {
                const newItem = {};
                Object.keys(item).forEach((key) => {
                    const newKey = key.replace(/\d+$/, newIndex + 1);
                    newItem[newKey] = item[key];
                });
                return newItem;
            });
        });
    };
    const handleInputChange = (e, index, setList) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        if (
            /^careerYearMonth(Start|End)\d+$/.test(name) ||
            /^licenseYearMonth\d+$/.test(name) ||
            /^activeYearMonth(Start|End)\d+$/.test(name)
        ) {
            let updatedValue = value.replace(/[^0-9]/g, '');
            let newCursorPosition = cursorPosition;

            if (updatedValue.length > 4) {
                if (!value.includes('-') && cursorPosition > 4) {
                    newCursorPosition += 1;
                }
                updatedValue = `${updatedValue.slice(0, 4)}-${updatedValue.slice(4)}`;
            }

            // giới hạn tháng từ 01 đến 12
            const [year, month] = updatedValue.split('-');
            if (month) {
                if (month.length > 2) {
                    updatedValue = `${year}-${month.slice(0, 2)}`;
                }
                if (parseInt(month, 10) > 12) {
                    updatedValue = `${year}-12`;
                }
            }

            setList((prev) => {
                const updatedList = [...prev];
                updatedList[index] = { ...updatedList[index], [name]: updatedValue };
                return updatedList;
            });

            // đặt lại vị trí con trỏ
            setTimeout(() => {
                e.target.selectionStart = newCursorPosition;
                e.target.selectionEnd = newCursorPosition;
            }, 0);
        } else {
            setList((prev) => {
                const updatedList = [...prev];
                updatedList[index] = { ...updatedList[index], [name]: value };
                return updatedList;
            });
        }
    };

    const handleDateChange = (name, value, index, setList) => {
        if (value) {
            value = moment(value).format('YYYY-MM');
        }
        if (
            /^careerYearMonth(Start|End)\d+$/.test(name) ||
            /^licenseYearMonth\d+$/.test(name) ||
            /^activeYearMonth(Start|End)\d+$/.test(name)
        ) {
            setList((prev) => {
                const updatedList = [...prev];
                updatedList[index] = { ...updatedList[index], [name]: value };
                return updatedList;
            });
        }
    };

    const handleCareerEndDateChange = (index, date) => {
        const name = `careerYearMonthEnd${index + 1}`;
        const value = date ? moment(date).format('YYYY-MM') : '';
        setCareerList((prev) => {
            const updatedList = [...prev];
            updatedList[index] = {
                ...updatedList[index],
                [name]: value,
                ...(value ? { [`working${index + 1}`]: 'N' } : {}),
            };
            return updatedList;
        });
    };

    const handleChangeInfo = (name, selectedValue, index, setList) => {
        setList((prev) => {
            const updatedList = [...prev];

            if (name.startsWith('careerSi')) {
                const matchedOption = resumeRegionSi.find((option) => option.code === selectedValue);
                const codeName = matchedOption ? matchedOption.codeName : selectedValue;

                updatedList[index] = {
                    ...updatedList[index],
                    [name]: codeName,
                };
            } else {
                updatedList[index] = {
                    ...updatedList[index],
                    [name]: selectedValue,
                };
            }

            return updatedList;
        });
    };

    const handleToggleWorking = (index) => {
        setCareerList((prev) => {
            const updatedList = [...prev];
            const key = index + 1;

            const currentValue = updatedList[index][`working${key}`];
            const nextValue = currentValue === 'Y' ? 'N' : 'Y';

            updatedList[index] = {
                ...updatedList[index],
                [`working${key}`]: nextValue,
                ...(nextValue === 'Y'
                    ? {
                        [`careerYearMonthEnd${key}`]: '',
                        [`reasonsLeave${key}`]: '',
                    }
                    : {}),
            };

            return updatedList;
        });
    };
    const generateCombinedString = (list, keys) => {
        const result = {};

        Object.keys(keys).forEach((key) => {
            result[key] = [];
            if (key === 'startYear' || key === 'endYear' || key === 'licenseYears') {
                result[`${keys[key]}Month`] = [];
            }
        });

        list.forEach((item, index) => {
            const nextIndex = index + 1;

            Object.entries(keys).forEach(([key, field]) => {
                if (key === 'startYear' || key === 'endYear' || key === 'licenseYears') {
                    result[key] = result[key] || [];
                    result[`${keys[key]}Month`] = result[`${keys[key]}Month`] || [];

                    const [year, month] = (item[`${field}${nextIndex}`] || '').split('-');
                    result[key].push(year || '');
                    result[`${field}Month`].push(month || '');
                } else {
                    result[key] = result[key] || [];
                    result[key].push(item[`${field}${nextIndex}`] || '');
                }
            });
        });

        return Object.values(result)
            .map((arr) => arr.join(','))
            .join('|');
    };

    const generateCombinedStringLicenseInfo = (list, keys) => {
        const result = {};

        Object.keys(keys).forEach((key) => {
            result[key] = [];
            if (key === 'startYear' || key === 'endYear' || key === 'licenseYears') {
                result[`${keys[key]}Month`] = [];
            }
        });

        list.forEach((item, index) => {
            const nextIndex = index + 1;

            Object.entries(keys).forEach(([key, field]) => {
                if (key === 'startYear' || key === 'endYear' || key === 'licenseYears') {
                    result[key] = result[key] || [];
                    result[`${keys[key]}Month`] = result[`${keys[key]}Month`] || [];

                    const [year, month] = (item[`${field}${nextIndex}`] || '').split('-');
                    result[key].push(year || '');
                    result[`${field}Month`].push(month || '');
                } else {
                    result[key] = result[key] || [];
                    result[key].push(item[`${field}${nextIndex}`] || '');
                }
            });
        });

        return Object.values(result)
            .map((arr) => arr.join('###'))
            .join('|');
    };


    const generateCombinedStringActiveInfo = (list, keys) => {
        const result = {};

        Object.keys(keys).forEach((key) => {
            result[key] = [];
            if (key === 'startYear' || key === 'endYear' || key === 'licenseYears') {
                result[`${keys[key]}Month`] = [];
            }
        });

        list.forEach((item, index) => {
            const nextIndex = index + 1;

            Object.entries(keys).forEach(([key, field]) => {
                if (key === 'startYear' || key === 'endYear' || key === 'licenseYears') {
                    result[key] = result[key] || [];
                    result[`${keys[key]}Month`] = result[`${keys[key]}Month`] || [];

                    const [year, month] = (item[`${field}${nextIndex}`] || '').split('-');
                    result[key].push(year || '');
                    result[`${field}Month`].push(month || '');
                } else {
                    result[key] = result[key] || [];
                    result[key].push(item[`${field}${nextIndex}`] || '');
                }
            });
        });

        return Object.values(result)
            .map((arr) => arr.join('###'))
            .join('|');
    };

    const generateCombinedStringCareerInfo = (list) => {
        const startYears = [];
        const startMonths = [];
        const endYears = [];
        const endMonths = [];
        const businessNames = [];
        const careerSis = [];
        const positions = [];
        const respons = [];
        const reasonsLeaves = [];
        const workings = [];

        list.forEach((item, index) => {
            const i = index + 1;

            const [startYear = '', startMonth = ''] =
                (item[`careerYearMonthStart${i}`] || '').split('-');

            const [endYear = '', endMonth = ''] =
                (item[`careerYearMonthEnd${i}`] || '').split('-');

            startYears.push(startYear || '');
            startMonths.push(startMonth || '');
            endYears.push(endYear || '');
            endMonths.push(endMonth || '');

            businessNames.push(item[`businessName${i}`] || '');
            careerSis.push(item[`careerSi${i}`] || '');
            positions.push(item[`position${i}`] || '');
            respons.push(item[`respon${i}`] || '');
            reasonsLeaves.push(item[`reasonsLeave${i}`] || '');
            workings.push(item[`working${i}`] || 'N');
        });

        return [
            startYears,
            startMonths,
            endYears,
            endMonths,
            businessNames,
            careerSis,
            positions,
            respons,
            reasonsLeaves,
            workings,
        ]
            .map((arr) => arr.join('###'))
            .join('|');
    };

    useEffect(() => {
        const careerKeys = {
            startYear: 'careerYearMonthStart',
            endYear: 'careerYearMonthEnd',
            businessNames: 'businessName',
            careerSiNames: 'careerSi',
            positions: 'position',
            responsibilities: 'respon',
            reasonsLeave: 'reasonsLeave',
            workings: 'working',
        };

        const licenseKeys = {
            licenseYears: 'licenseYearMonth',
            licenseNames: 'licenseName',
            licensePlaces: 'licensePlace',
            licenseTypes: 'licenseType',
            licenseNumbers: 'licenseNumber',
        };

        const activeKeys = {
            startYear: 'activeYearMonthStart',
            endYear: 'activeYearMonthEnd',
            places: 'place',
            contents: 'content',
            types: 'type',
        };

        const careerInfo = generateCombinedStringCareerInfo(careerList);

        setPayload((prev) => ({
            ...prev,
            resumeCareerInfo: careerInfo || '',
            resumeLicenseInfo: generateCombinedStringLicenseInfo(licenseList, licenseKeys) || '',
            resumeActiveInfo: generateCombinedStringActiveInfo(activeResumeList, activeKeys) || '',
        }));
    }, [careerList, licenseList, activeResumeList]);

    useEffect(() => {
        const resultSchoolInfo = Object.values(formResumeSchoolInfo)
            .map((arr) => arr.join(','))
            .join('|');

        setPayload({
            ...payload,
            resumeSchoolInfo: resultSchoolInfo,
        });
        // eslint-disable-next-line
    }, [formResumeSchoolInfo]);

    const handleDeleteFile = () => {
        if (window.confirm('등록된 이미지를 삭제하시겠습니까?')) {
            setFileAvatar(null);
            setDeletedOldAvatar('Y')
            setPreviewUrl(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            alert('삭제되었습니다.');
        }
    };

    const handleCroppedImage = (croppedImageUrl, croppedFile) => {
        setPreviewUrl(croppedImageUrl);
        setFileAvatar(croppedFile);
        setOriginalFileName(croppedFile.name);
        setShowCropper(false);
    };

    const handleUpdateResumeSchoolInfo = (data, indices) => {
        const parts = data.split('|');
        const cvParts = parts
            .map((part, partIndex) => {
                const items = part.split(',');

                if (indices.length === 1 && indices[0] === 1) {
                    if (partIndex === 7) {
                        return ',,';
                    }
                    if (partIndex === 9) {
                        return ',4.0,4.0';
                    }
                } else {
                    if (partIndex === 7 || partIndex === 9) {
                        return part;
                    }
                }

                // For other parts, filter based on indices
                const resultItems = [];
                for (let i = 0; i < indices.length; i++) {
                    const index = indices[i] - 1; // Adjust for 0-based indexing
                    resultItems.push(index < items.length ? items[index] : '');
                }

                // Ensure each part has 3 elements, padding with empty strings
                while (resultItems.length < 3) {
                    resultItems.push('');
                }

                return resultItems.join(',');
            })
            .join('|');

        return cvParts;
    };
    const requiredFields = [
        'title',
        'resumeSchoolInfo',
        'resumeLvl',
        'nameKor',
        'mobileNo',
        'email',
        'contactMethod',
        'proposeSMS',
        'resumeClass',
        'resumeLicense',
        'resumeForm',
        'resumeRegionSi1',
        'resumeRegionGu1',
        'resumePay',
        'resumePosition',
        'resumeDay',
        'resumeGrade',
    ];

    const requiredFieldSplit = {
        '001': ['schoolName1', 'yearMonthStart1', 'yearMonthEnd1'],
        '009': ['grade2', 'schoolName2', 'yearMonthStart2', 'yearMonthEnd2', 'status2', 'major2', 'gpa2'],
        '013': ['grade3', 'schoolName3', 'yearMonthStart3', 'yearMonthEnd3', 'status3', 'major3', 'gpa3'],
    };

    const lengthValidations = {
        title: 100,
        nameKor: 20,
        telNo: 14,
        mobileNo: 14,
        email: 50,
        homeUrl: 100,
        resumePayEtc: 50,
    };
    const labelInputRequired = {
        title: '이력서 등록',
        nameKor: '이름',
        mobileNo: '휴대폰',
        email: '이메일',
        homeUrl: '포트폴리오',
        resumePayEtc: '희망 급여 (직접입력)',
    };

    function getTextError(field) {
        switch (field) {
            case 'title':
                return '이력서 제목을 입력해 주세요.';
            case 'nameKor':
                return '이름을 입력해 주세요.';
            case 'mobileNo':
                return '휴대폰번호를 입력해 주세요.';
            case 'email':
                return '이메일주소를 입력해 주세요.';
            case 'invalidMobileNo':
                return '유효하지 않는 전화번호입니다.';
            case 'invalidEmail':
                return '유효하지 않은 이메일 주소입니다.';
            case 'resumeClass':
                return '희망업무를 선택해 주세요.';
            case 'resumeLicense':
                return '소지 자격/면허증 정보를 선택해 주세요.';
            case 'resumeForm':
                return '희망 근무형태를 선택해 주세요.';
            case 'resumeRegionSi1':
                return '희망 근무지역을 선택해 주세요.';
            case 'resumeRegionGu1':
                return '희망 근무지역을 선택해 주세요.';
            case 'resumePay':
                return '희망 급여를 선택해 주세요.';
            case 'resumePayEtc':
                return '희망 급여를 입력해 주세요.';
            case 'resumePosition':
                return '희망 직급을 선택해 주세요';
            case 'resumeDay':
                return '희망 근무요일을 선택해 주세요.';
            case 'resumeDayEtc':
                return '희망 근무요일을 입력해 주세요.';
            case 'resumeSchoolInfo':
                return '학력사항 입력해 주세요';
            case 'resumeLvl':
                return '이력서 공개여부 선택해 주세요';
            case 'contactMethod':
                return '희망연락방법 선택해 주세요';
            case 'proposeSMS':
                return '덴탈잡 쪽지 SMS 알림 선택해 주세요';
            case 'yearMonthStart1':
                return '입학 연도를 YYYY-MM 형식으로 입력해 주세요.';
            case 'yearMonthEnd1':
                return '졸업 연도를 YYYY-MM 형식으로 입력해 주세요.';
            case 'yearMonthStart2':
                return '입학 연도를 YYYY-MM 형식으로 입력해 주세요.';
            case 'yearMonthEnd2':
                return '졸업 연도를 YYYY-MM 형식으로 입력해 주세요.';
            case 'yearMonthStart3':
                return '입학 연도를 YYYY-MM 형식으로 입력해 주세요.';
            case 'yearMonthEnd3':
                return '졸업 연도를 YYYY-MM 형식으로 입력해 주세요.';
            case 'major2':
                return '전공명을 입력해 주세요.';
            case 'major3':
                return '전공명을 입력해 주세요.';
            case 'gpa2':
                return '학점을 입력해 주세요.';
            case 'gpa3':
                return '학점을 입력해 주세요.';
            case 'grade2':
                return '학교 구분을 선택해 주세요.';
            case 'grade3':
                return '학교 구분을 선택해 주세요.';
            case 'schoolName1':
                return '학교명을 입력해 주세요.';
            case 'schoolName2':
                return '학교명을 입력해 주세요.';
            case 'schoolName3':
                return '학교명을 입력해 주세요.';
            case 'status2':
                return '졸업 상태를 선택해 주세요.';
            case 'status3':
                return '졸업 상태를 선택해 주세요.';
            default:
                return '(*) 표시는 필수 입력 항목입니다';
        }
    }

    const validateYearMonthSchoolInfo = (yearStart, yearEnd, monthStart, monthEnd, resumeGrade) => {
        const regex = /^\d{4}-(0[1-9]|1[0-2])$/;
        let indexesToCheck = [];

        // Xác định các chỉ số cần kiểm tra dựa trên resumeGrade
        if (resumeGrade === '001') {
            indexesToCheck = [0];
        } else if (resumeGrade === '009') {
            indexesToCheck = [0, 1];
        } else if (resumeGrade === '013') {
            indexesToCheck = [0, 1, 2];
        }

        // Duyệt qua các chỉ số cần kiểm tra
        for (let i = 0; i < indexesToCheck.length; i++) {
            const index = indexesToCheck[i];
            const startYear = yearStart[index] || '';
            const startMonth = monthStart[index] || '';
            const endYear = yearEnd[index] || '';
            const endMonth = monthEnd[index] || '';

            // Kiểm tra trường nhập học (start)
            if (startYear || startMonth) {
                console.log('startYear ', startYear, 'startMonth', startMonth)
                if (!startYear || !startMonth || !regex.test(`${startYear}-${startMonth}`)) {
                    return {
                        error: '입학 연도를 YYYY-MM 형식으로 입력해 주세요.',
                        focusField: `yearMonthStart${index + 1}`,
                    };
                }
            }

            // Kiểm tra trường tốt nghiệp (end)
            if (endYear || endMonth) {
                if (!endYear || !endMonth || !regex.test(`${endYear}-${endMonth}`)) {
                    return {
                        error: '졸업 연도를 YYYY-MM 형식으로 입력해 주세요.',
                        focusField: `yearMonthEnd${index + 1}`,
                    };
                }
            }
        }

        // Nếu không có lỗi, trả về null
        return null;
    };

    const validateForm = (data) => {
        let errors = {};
        let missingFields = requiredFields.filter((field) => !data[field] || data[field].trim() === '');

        const gradesToValidate = Object.keys(requiredFieldSplit).filter(
            (grade) => parseInt(grade, 10) <= parseInt(payload.resumeGrade, 10),
        );

        // Kiểm tra các trường bắt buộc khác
        gradesToValidate.forEach((grade) => {
            requiredFieldSplit[grade].forEach((fieldName) => {
                if (fieldName === 'grade2' && formResumeSchoolInfo.grade[1] === '') {
                    handleFocus('grade2');
                    missingFields.push(fieldName);
                }
                if (fieldName === 'grade3' && formResumeSchoolInfo.grade[2] === '') {
                    handleFocus('grade3');
                    missingFields.push(fieldName);
                }

                if (fieldName === 'status2' && formResumeSchoolInfo.status[1] === '') {
                    handleFocus('status2');
                    missingFields.push(fieldName);
                }
                if (fieldName === 'status3' && formResumeSchoolInfo.status[2] === '') {
                    handleFocus('status3');
                    missingFields.push(fieldName);
                }

                if (fieldName === 'yearMonthEnd2' && formResumeSchoolInfo.status[1] === '재학') {
                    return;
                }
                if (fieldName === 'yearMonthEnd3' && formResumeSchoolInfo.status[2] === '재학') {
                    return;
                }

                // Bỏ qua gpa nếu đang học (재학)
                if (fieldName === 'gpa2' && formResumeSchoolInfo.status[1] === '재학') {
                    return;
                }
                if (fieldName === 'gpa3' && formResumeSchoolInfo.status[2] === '재학') {
                    return;
                }

                const inputElement = document.querySelector(`[name="${fieldName}"]`);
                if (inputElement && inputElement?.value?.trim() === '') {
                    missingFields.push(fieldName);
                }
            });
        });

        if (data.resumePay === '999' && (!data.resumePayEtc || data.resumePayEtc.trim() === '')) {
            missingFields.push('resumePayEtc');
        }
        if (data.resumeDay === '999' && (!data.resumeDayEtc || data.resumeDayEtc.trim() === '')) {
            missingFields.push('resumeDayEtc');
        }

        if (data.mobileNo && !/^[0-9]{2,3}[0-9]{3,4}[0-9]{4}$/.test(data.mobileNo.replace(/-/g, ''))) {
            errors['mobileNo'] = getTextError('invalidMobileNo');
            handleFocus('mobileNo');
            return errors;
        }

        if (data.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
            errors['email'] = getTextError('invalidEmail');
            handleFocus('email');
            return errors;
        }

        if (missingFields.length > 0) {
            const firstMissingField = missingFields[0];
            errors[firstMissingField] = getTextError(firstMissingField);
            handleFocus(firstMissingField);
        } else {
            for (const field in lengthValidations) {
                if (data[field] && data[field].length > lengthValidations[field]) {
                    errors[
                        field
                    ] = `${labelInputRequired[field]} 최대 ${lengthValidations[field]} 글자까지만 입력이 가능합니다.`;
                    handleFocus(field);
                }
            }
        }

        return errors ? errors : {};
    };

    const validateCareerList = (careerList) => {
        const errors = [];

        careerList.forEach((career, index) => {
            const yearMonthStart = career[`careerYearMonthStart${index + 1}`];
            const yearMonthEnd = career[`careerYearMonthEnd${index + 1}`];
            const businessName = career[`businessName${index + 1}`];
            const reasonsLeave = career[`reasonsLeave${index + 1}`];
            const respon = career[`respon${index + 1}`];
            const working = career[`working${index + 1}`];
            const careerSi = career[`careerSi${index + 1}`];
            const position = career[`position${index + 1}`];

            const startMatch = yearMonthStart.match(/^\d{4}-\d{2}$/);
            const endMatch = yearMonthEnd.match(/^\d{4}-\d{2}$/);

            if (!businessName) {
                errors.push({
                    error: `치과명을 입력해 주세요.`,
                    focusField: `businessName${index + 1}`,
                });
                return;
            }

            if (!startMatch) {
                errors.push({
                    error: `입사 연월을 YYYY-MM 형식으로 입력해 주세요.`,
                    focusField: `careerYearMonthStart${index + 1}`,
                });
                return;
            }

            if (!endMatch && working === 'N') {
                errors.push({
                    error: `퇴사 연월을 YYYY-MM 형식으로 입력해 주세요.`,
                    focusField: `careerYearMonthEnd${index + 1}`,
                });
                return;
            }

            if (!careerSi) {
                errors.push({
                    error: `근무지역을 선택해 주세요.`,
                    focusField: `careerSi${index + 1}`,
                });
            }

            if (!position) {
                errors.push({
                    error: `직급/직책을 선택해 주세요.`,
                    focusField: `position${index + 1}`,
                });
            }

            if (!reasonsLeave && working === 'N') {
                errors.push({
                    error: `퇴사 사유를 입력해 주세요.`,
                    focusField: `reasonsLeave${index + 1}`,
                });
                return;
            }

            if (!respon) {
                errors.push({
                    error: `담당업무를 입력해 주세요.`,
                    focusField: `respon${index + 1}`,
                });
                return;
            }
        });

        return errors.length > 0 ? errors : null;
    };

    const validateLicenseList = (licenseList) => {
        const errors = [];

        licenseList.forEach((license, index) => {
            const licenseYearMonth = license[`licenseYearMonth${index + 1}`];
            const licenseName = license[`licenseName${index + 1}`];
            const licenseNumber = license[`licenseNumber${index + 1}`];
            const licensePlace = license[`licensePlace${index + 1}`];
            const licenseType = license[`licenseType${index + 1}`];

            const match = licenseYearMonth.match(/^\d{4}-\d{2}$/);
            if (!licenseType) {
                errors.push({
                    error: `자격/면허정보 구분을 선택해  주세요.`,
                    focusField: `licenseType${index + 1}`,
                });
            }
            if (!licenseName) {
                errors.push({
                    error: `자격/면허명을 입력해 주세요.`,
                    focusField: `licenseName${index + 1}`,
                });
            }

            if (!licenseNumber) {
                errors.push({
                    error: `자격/면허번호를 입력해 주세요.`,
                    focusField: `licenseNumber${index + 1}`,
                });
            }

            if (!licensePlace) {
                errors.push({
                    error: `발행처를 입력해 주세요.`,
                    focusField: `licensePlace${index + 1}`,
                });
            }

            if (!match) {
                errors.push({
                    error: `취득 연월을 YYYY-MM 형식으로 입력해 주세요.`,
                    focusField: `licenseYearMonth${index + 1}`,
                });
            }
        });

        return errors.length > 0 ? errors : null;
    };

    const validateActiveResumeList = (activeResumeList) => {
        const errors = [];

        activeResumeList.forEach((resume, index) => {
            const yearMonthStart = resume[`activeYearMonthStart${index + 1}`];
            const yearMonthEnd = resume[`activeYearMonthEnd${index + 1}`];
            const place = resume[`place${index + 1}`];
            const content = resume[`content${index + 1}`];
            const type = resume[`type${index + 1}`];

            const startMatch = yearMonthStart.match(/^\d{4}-\d{2}$/);
            const endMatch = yearMonthEnd.match(/^\d{4}-\d{2}$/);
            if (!type) {
                errors.push({
                    error: '활동 종류를 선택해 주세요.',
                    focusField: `type${index + 1}`,
                });
            }
            if (!place) {
                errors.push({
                    error: `기관/장소를 입력해 주세요.`,
                    focusField: `place${index + 1}`,
                });
                return;
            }

            if (!startMatch) {
                errors.push({
                    error: `시작 연월을 YYYY-MM 형식으로 입력해 주세요.`,
                    focusField: `activeYearMonthStart${index + 1}`,
                });
                return;
            }

            if (!endMatch) {
                errors.push({
                    error: `종료 연월을 YYYY-MM 형식으로 입력해 주세요`,
                    focusField: `activeYearMonthEnd${index + 1}`,
                });
                return;
            }

            if (!content) {
                errors.push({
                    error: `활동 내용을 입력해 주세요.`,
                    focusField: `content${index + 1}`,
                });
                return;
            }
        });

        return errors.length > 0 ? errors : null;
    };

    // const submitForm = async () => {
    //     console.log(payload.resumeCareerInfo);
    // }
    // nút 저장완료
    const submitForm = async () => {
        try {
            const { data } = await getCommonInfoImg();
            if (data.memberBlocked === 'Y') {
                alert('등록 불가능한 회원입니다.');
                return;
            }

            const yearMonthError = validateYearMonthSchoolInfo(
                formResumeSchoolInfo.yearStart,
                formResumeSchoolInfo.yearEnd,
                formResumeSchoolInfo.monthStart,
                formResumeSchoolInfo.monthEnd,
                payload.resumeGrade,
            );
            if (yearMonthError !== null) {
                window.alert(yearMonthError.error);
                handleFocus(yearMonthError.focusField);
                return;
            }

            const errors = validateForm(payload);
            if (Object.keys(errors).length > 0) {
                let logMessage = '';
                for (const field in errors) {
                    logMessage += `${errors[field]}\n`;
                }
                logMessage = logMessage.slice(0, -1);
                window.alert(logMessage);
                return;
            }

            const yearMonthCareerError = validateCareerList(careerList);
            if (yearMonthCareerError && payload.resumeCareer === '009') {
                const firstError = yearMonthCareerError[0];
                window.alert(firstError.error);
                handleFocus(firstError.focusField);
                return;
            }

            if (payload.resumeCareer === '009' && payload.resumeCareerYear === '') {
                window.alert('총 경력을 입력해 주세요.');
                handleFocus('resumeCareerYear');
                return;
            }

            const licenseErrors = validateLicenseList(licenseList);
            if (licenseErrors && payload.resumeLicenseYn === 'Y') {
                const firstError = licenseErrors[0];
                window.alert(firstError.error);
                handleFocus(firstError.focusField);
                return;
            }

            const activeResumeErrors = validateActiveResumeList(activeResumeList);
            if (activeResumeErrors && payload.resumeActiveYn === 'Y') {
                const firstError = activeResumeErrors[0];
                window.alert(firstError.error);
                handleFocus(firstError.focusField);
                return;
            }

            if (payload.resumeCareer === '001') {
                payload.resumeCareerInfo = '';
            }
            if (payload.resumeLicenseYn === 'N') {
                payload.resumeLicenseInfo = '';
            }
            if (payload.resumeActiveYn === 'N') {
                payload.resumeActiveInfo = '';
            }

            if (payload.resumeGrade === '001') {
                payload.resumeSchoolInfo = handleUpdateResumeSchoolInfo(payload.resumeSchoolInfo, [1]);
            }
            if (payload.resumeGrade === '009') {
                payload.resumeSchoolInfo = handleUpdateResumeSchoolInfo(payload.resumeSchoolInfo, [1, 2]);
            }
            if (payload.resumeGrade === '013') {
                payload.resumeSchoolInfo = handleUpdateResumeSchoolInfo(payload.resumeSchoolInfo, [1, 2, 3]);
            }

            if (payload.resumeContent === '') {
                alert('자기소개서를 작성해 주세요.');
                handleFocus('resumeContent');
                return;
            }

            const isComfirm = id ? window.confirm('저장하시겠습니까?') : window.confirm(MESSAGE.confirm.create);
            if (!isComfirm) return;

            const formData = new FormData();
            payload.mobileNo = formatPhoneNumber(payload.mobileNo);
            payload.ftsContents = '';
            payload.dspName = 'Y';
            payload.dspMobile = 'Y';
            payload.dspTel = 'Y';
            payload.telNo = '';
            payload.dspEmail = 'Y';
            payload.dspHome = 'Y';
            // payload.resumeCareerEtc = '';
            payload.deletedOldAvatar = deletedOldAvatar;
            payload.title = payload.title.replace('(임시저장)', '').trim();

            delete payload.resumePosition2;
            delete payload.memberID;
            delete payload.isChoice;
            delete payload.resumeLogo;

            formData.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));

            if (fileAvatar) {
                formData.append('avatar', fileAvatar, originalFileName);
            }

            if (id) {
                try {
                    await putPAIAB010(formData);
                    window.alert(MESSAGE.notify.updateSuccess);
                    navigate(`/paiab020`);
                } catch (error) {
                    console.error(error);
                    window.alert(MESSAGE.notify.updateError);
                }
            } else {
                try {
                    await postPAIAB010(formData);
                    window.alert(MESSAGE.notify.createSuccess);
                    navigate(`/paiab020`);
                } catch (error) {
                    console.error(error);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        if (payload.resumeRegionSi1) {
            setSelectedSi1(payload.resumeRegionSi1);
        }
        if (payload.resumeRegionSi2) {
            setSelectedSi2(payload.resumeRegionSi2);
        }
        if (payload.resumeRegionSi3) {
            setSelectedSi3(payload.resumeRegionSi3);
        }
    }, [payload, careerList]);

    const calculateExperience = (data) => {
        let periods = [];

        data.forEach((item) => {
            const startKey = Object.keys(item).find((k) => k.startsWith('careerYearMonthStart'));
            const endKey = Object.keys(item).find((k) => k.startsWith('careerYearMonthEnd'));
            const workingKey = Object.keys(item).find((k) => k.startsWith('working'));

            if (startKey && item[startKey]) {
                const startDate = new Date(item[startKey] + '-01');
                let endDate = null;

                if (workingKey && item[workingKey] === 'Y') {
                    endDate = new Date();
                } else if (endKey && item[endKey]) {
                    endDate = new Date(item[endKey] + '-01');
                }

                if (startDate instanceof Date && !isNaN(startDate) && endDate instanceof Date && !isNaN(endDate)) {
                    periods.push({ start: startDate, end: endDate });
                }
            }
        });

        if (periods.length === 0) return '';

        periods.sort((a, b) => a.start - b.start);

        const merged = [];
        let cur = periods[0];

        for (let i = 1; i < periods.length; i++) {
            const next = periods[i];

            if (cur.end >= next.start) {

                cur.end = new Date(Math.max(cur.end, next.end));
            } else {
                merged.push(cur);
                cur = next;
            }
        }
        merged.push(cur);

        const totalMonths = merged.reduce((sum, p) => {
            const yearsDiff = p.end.getFullYear() - p.start.getFullYear();
            const monthsDiff = p.end.getMonth() - p.start.getMonth();

            return sum + (yearsDiff * 12 + monthsDiff + 1);
        }, 0);

        const years = Math.max(0, Math.floor(totalMonths / 12));
        return `${years}`;
    };


    useEffect(() => {
        const years = calculateExperience(careerList);
        setPayload((prev) => ({ ...prev, resumeCareerYear: years }));
    }, [careerList]);

    // nút 임시저장
    const requiredFields2 = ['nameKor', 'mobileNo', 'email', 'contactMethod', 'proposeSMS'];
    const validateForm2 = (data) => {
        let errors = {};
        let missingFields = requiredFields2.filter((field) => !data[field] || data[field].trim() === '');

        if (data.mobileNo && !/^[0-9]{2,3}[0-9]{3,4}[0-9]{4}$/.test(data.mobileNo.replace(/-/g, ''))) {
            errors['mobileNo'] = getTextError('invalidMobileNo');
            handleFocus('mobileNo');
            return errors;
        }

        if (data.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
            errors['email'] = getTextError('invalidEmail');
            handleFocus('email');
            return errors;
        }
        if (missingFields.length > 0) {
            const firstMissingField = missingFields[0];
            errors[firstMissingField] = getTextError(firstMissingField);
            handleFocus(firstMissingField);
        } else {
            for (const field in lengthValidations) {
                if (data[field] && data[field].length > lengthValidations[field]) {
                    errors[
                        field
                    ] = `${labelInputRequired[field]} 최대 ${lengthValidations[field]} 글자까지만 입력이 가능합니다.`;
                    handleFocus(field);
                }
            }
        }

        return errors ? errors : {};
    };

    // nút 임시저장
    const submitForm2 = async () => {
        try {
            const { data } = await getCommonInfoImg();
            if (data.memberBlocked === 'Y') {
                alert('등록 불가능한 회원입니다.');
                return;
            }
            const errors = validateForm2(payload);
            if (Object.keys(errors).length > 0) {
                let logMessage = '';
                for (const field in errors) {
                    logMessage += `${errors[field]}\n`;
                }
                logMessage = logMessage.slice(0, -1);
                window.alert(logMessage);
                return;
            }
            const isComfirm = id ? window.confirm('저장하시겠습니까?') : window.confirm('임시저장 하시겠습니까?');
            if (!isComfirm) return;
            const formData = new FormData();
            if (id) {
                payload.seq = id;
            }
            payload.mobileNo = formatPhoneNumber(payload.mobileNo);
            payload.ftsContents = '';
            payload.dspName = 'Y';
            payload.dspMobile = 'Y';
            payload.dspTel = 'Y';
            payload.telNo = '';
            payload.dspEmail = 'Y';
            payload.dspHome = 'Y';
            // payload.resumeCareerEtc = '';
            if (!payload.title || payload.title === '') {
                payload.title = data?.nameKor + '님의 이력서입니다.';
            } else if (!payload.title.endsWith('(임시저장)')) {
                payload.title = payload.title + ' (임시저장)';
            }
            const fieldsToEnsureEmptyString = [
                'avatar',
                'resumeSchoolInfo',
                'resumeLvl',
                'nameKor',
                'mobileNo',
                'email',
                'contactMethod',
                'proposeSMS',
                'resumeClass',
                'resumeLicense',
                'resumeForm',
                'resumeRegionSi1',
                'resumeRegionGu1',
                'resumePay',
                'resumePosition',
                'resumeDay',
                'resumeGrade',
            ];
            for (const fieldName of fieldsToEnsureEmptyString) {
                if (!payload[fieldName]) {
                    payload[fieldName] = '';
                }
            }
            payload.resumeLvl = 'N';
            payload.deletedOldAvatar = deletedOldAvatar;
            delete payload.resumePosition2;
            delete payload.memberID;
            delete payload.isChoice;
            delete payload.resumeLogo;
            formData.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
            if (fileAvatar) {
                formData.append('avatar', fileAvatar, originalFileName);
            }
            if (id) {
                try {
                    const res = await putPAIAB010(formData);
                    window.alert('임시 저장이 완료되었습니다.');
                    // navigate(`/paiab010-${res.data.seq}`);
                    window.location.href = `/paiab010-${res.data.seq}`;
                } catch (error) {
                    console.error(error);
                    window.alert(MESSAGE.notify.updateError);
                }
            } else {
                try {
                    const res = await postPAIAB010(formData);
                    window.alert('임시 저장이 완료되었습니다.');
                    navigate(`/paiab010-${res.data.seq}`);
                } catch (error) {
                    console.error(error);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <div id="content" className="sub-page">
            <div className="container">
                <div id="top-sub-page">
                    <SideNav />
                    <div className="resume">
                        <div className="resume__inner">
                            <h3 className="resume__tit">이력서 등록</h3>
                            <div className="resume__block resume__block-title">
                                <input
                                    type="text"
                                    className="resume__sbj resume__block-input"
                                    name="title"
                                    onChange={handleChange}
                                    value={payload.title || ''}
                                    required
                                />
                                {!payload.title && (
                                    <div className="resume__placeholer resume__block-placeholer">
                                        이력서 제목을 입력하세요.
                                        <span>(필수입력사항)</span>
                                    </div>
                                )}
                            </div>
                            <div className="resume__tit-box">
                                <h4 className="resume__tit2">
                                    이력서 공개여부<span>*</span>
                                </h4>
                                <div className="resume__check resume__check--gap50">
                                    <label className="resume__label">
                                        <input
                                            type="radio"
                                            className="resume__checkbox"
                                            value="Y"
                                            name="resumeLvl"
                                            checked={payload.resumeLvl === 'Y'}
                                            onChange={handleChange}
                                        />
                                        <span>공개</span>
                                    </label>
                                    <label className="resume__label">
                                        <input
                                            type="radio"
                                            className="resume__checkbox"
                                            value="N"
                                            name="resumeLvl"
                                            checked={payload.resumeLvl === 'N'}
                                            onChange={handleChange}
                                        />
                                        <span>비공개</span>
                                    </label>
                                </div>
                            </div>
                            <div className="resume__desc">
                                <span>이력서 공개 기간은 별도 제한이 없으며, 비공개를 원하시는 선생님께서는 별도로 비공개 설정 부탁드립니다.</span>
                                <span>
                                    비공개처리된 이력서는 [추천 인재]과 [인재 소식] 에 등록되지 않으며, 회원님만 보실
                                    수 있습니다.
                                </span>
                            </div>
                            <div className="resume__tit-box resume__tit-box--between">
                                <h4 className="resume__tit2">인적사항</h4>
                                <div className="resume__wrn">
                                    <span>*</span> 필수 입력정보 입니다.
                                </div>
                            </div>
                            <div className="resume__block" style={{ paddingBottom: '40px' }}>
                                <div className="resume__grid">
                                    <div className="resume__input-box">
                                        <label htmlFor="name" className="esn">
                                            이름
                                        </label>
                                        <input
                                            className="resume__input"
                                            type="text"
                                            id="name"
                                            name="nameKor"
                                            value={payload.nameKor || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="resume__input-box">
                                        <label htmlFor="phone" className="esn">
                                            휴대폰
                                        </label>
                                        <input
                                            className="resume__input"
                                            type="text"
                                            id="phone"
                                            name="mobileNo"
                                            value={payload.mobileNo || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="resume__input-box">
                                        <label htmlFor="portfolio">포트폴리오</label>
                                        <input
                                            className="resume__input"
                                            type="text"
                                            id="portfolio"
                                            placeholder="https://"
                                            name="homeUrl"
                                            value={payload.homeUrl || ''}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="resume__input-box">
                                        <label htmlFor="email" className="esn">
                                            이메일
                                        </label>
                                        <input
                                            className="resume__input"
                                            type="text"
                                            id="email"
                                            value={payload.email || ''}
                                            onChange={handleChange}
                                            name="email"
                                            required
                                        />
                                    </div>
                                    <div className="resume__file">
                                        {!fileAvatar && !previewUrl && (
                                            <label onClick={() => setShowCropper(true)}>+ 사진등록</label>
                                        )}

                                        <div className="resume__preview">
                                            {previewUrl && fileAvatar && (
                                                <img src={previewUrl} alt="Preview" className="resume__image" />
                                            )}

                                            {previewUrl && !fileAvatar && (
                                                <ImageCheckFallback
                                                    folderName={'resume_logo'}
                                                    imgName={payload?.resumeLogo}
                                                    classImg={'resume__image'}
                                                    alt="Preview"
                                                />
                                            )}
                                        </div>
                                        {fileAvatar || previewUrl ? (
                                            <button
                                                type="button"
                                                className="resume__delete-btn"
                                                onClick={handleDeleteFile}
                                            ></button>
                                        ) : null}

                                        {showCropper && (
                                            <ImageCropper
                                                isOpen={showCropper}
                                                onClose={() => setShowCropper(false)}
                                                onCrop={handleCroppedImage}
                                                memberID={memberID}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="resume__grid">
                                    <div className="resume__col">
                                        <h4 className="resume__tit3 resume__tit3--esn">희망연락방법</h4>
                                        <div className="resume__check">
                                            <label className="resume__label">
                                                <input
                                                    type="checkbox"
                                                    className="resume__checkbox"
                                                    name="contactMethod"
                                                    value="mob"
                                                    checked={(payload.contactMethod ?? '').split(',').includes('mob')}
                                                    onChange={handleCheckBox}
                                                />
                                                <span>휴대폰</span>
                                            </label>
                                            <label className="resume__label">
                                                <input
                                                    type="checkbox"
                                                    className="resume__checkbox"
                                                    name="contactMethod"
                                                    value="eml"
                                                    checked={(payload.contactMethod ?? '').split(',').includes('eml')}
                                                    onChange={handleCheckBox}
                                                />
                                                <span>이메일</span>
                                            </label>
                                            <label className="resume__label">
                                                <input
                                                    type="checkbox"
                                                    className="resume__checkbox"
                                                    name="contactMethod"
                                                    value="pps"
                                                    checked={(payload.contactMethod ?? '').split(',').includes('pps')}
                                                    onChange={handleCheckBox}
                                                />
                                                <span>덴탈잡 쪽지</span>
                                            </label>
                                        </div>
                                        <p className="resume__ps">선택하신 연락방법은 '공개'로 설정됩니다.</p>
                                    </div>
                                    <div className="resume__col">
                                        <h4 className="resume__tit3 resume__tit3--esn">덴탈잡 쪽지 SMS 알림</h4>
                                        <div className="resume__check">
                                            <label className="resume__label">
                                                <input
                                                    type="radio"
                                                    className="resume__radio"
                                                    value="Y"
                                                    name="proposeSMS"
                                                    checked={payload.proposeSMS === 'Y'}
                                                    onChange={handleChange}
                                                />
                                                <span>수신허용</span>
                                            </label>
                                            <label className="resume__label">
                                                <input
                                                    type="radio"
                                                    className="resume__radio"
                                                    value="N"
                                                    name="proposeSMS"
                                                    checked={payload.proposeSMS === 'N'}
                                                    onChange={handleChange}
                                                />
                                                <span>수신불가</span>
                                            </label>
                                        </div>
                                        <p className="resume__ps" style={{ position: 'absolute' }}>
                                            '수신허용'을 선택하시면 구인기관에서 덴탈잡 쪽지를 보낼시 회원님의
                                            <br />
                                            핸드폰으로 문자 알림을 받을 수 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="resume__tit-box">
                                <h4 className="resume__tit2">희망근무조건</h4>
                            </div>
                            <div className="resume__block">
                                <div className="resume__div">
                                    <h4 className="resume__tit3 resume__tit3--esn">희망업무</h4>
                                    <div className="resume__check">
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeClass"
                                                value="001"
                                                checked={(payload.resumeClass ?? '').split(',').includes('001')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>진료실</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeClass"
                                                value="002"
                                                checked={(payload.resumeClass ?? '').split(',').includes('002')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>데스크</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeClass"
                                                value="003"
                                                checked={(payload.resumeClass ?? '').split(',').includes('003')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>상담</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeClass"
                                                value="004"
                                                checked={(payload.resumeClass ?? '').split(',').includes('004')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>보험청구</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeClass"
                                                value="005"
                                                checked={(payload.resumeClass ?? '').split(',').includes('005')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>치과내 기공실</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeClass"
                                                value="006"
                                                checked={(payload.resumeClass ?? '').split(',').includes('006')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>치과기공소</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeClass"
                                                value="007"
                                                checked={(payload.resumeClass ?? '').split(',').includes('007')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>관리 및 경영지원</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeClass"
                                                value="008"
                                                checked={(payload.resumeClass ?? '').split(',').includes('008')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>교정부문</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeClass"
                                                value="009"
                                                checked={(payload.resumeClass ?? '').split(',').includes('009')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>소독관리사</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeClass"
                                                value="999"
                                                checked={(payload.resumeClass ?? '').split(',').includes('999')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>기타</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="resume__div">
                                    <h4 className="resume__tit3 resume__tit3--esn">소지 자격/면허증</h4>
                                    <div className="resume__check">
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeLicense"
                                                value="001"
                                                checked={(payload.resumeLicense ?? '').split(',').includes('001')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>치과위생사</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeLicense"
                                                value="002"
                                                checked={(payload.resumeLicense ?? '').split(',').includes('002')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>치과기공사</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeLicense"
                                                value="003"
                                                checked={(payload.resumeLicense ?? '').split(',').includes('003')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>간호조무사</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeLicense"
                                                value="004"
                                                checked={(payload.resumeLicense ?? '').split(',').includes('004')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>보험청구사</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeLicense"
                                                value="005"
                                                checked={(payload.resumeLicense ?? '').split(',').includes('005')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>코디네이터</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeLicense"
                                                value="006"
                                                checked={(payload.resumeLicense ?? '').split(',').includes('006')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>의료관광 코디네이터</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeLicense"
                                                value="007"
                                                checked={(payload.resumeLicense ?? '').split(',').includes('007')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>기타</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="resume__div">
                                    <h4 className="resume__tit3 resume__tit3--esn">희망 근무형태</h4>
                                    <div className="resume__check">
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeForm"
                                                value="001"
                                                checked={(payload.resumeForm ?? '').split(',').includes('001')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>정규직</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeForm"
                                                value="002"
                                                checked={(payload.resumeForm ?? '').split(',').includes('002')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>계약직</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeForm"
                                                value="003"
                                                checked={(payload.resumeForm ?? '').split(',').includes('003')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>아르바이트</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                name="resumeForm"
                                                value="004"
                                                checked={(payload.resumeForm ?? '').split(',').includes('004')}
                                                onChange={handleCheckBox}
                                            />
                                            <span>실습생</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="resume__div">
                                    <h4 className="resume__tit3 resume__tit3--esn">희망 근무지역</h4>
                                    <div className="resume__flex pl40">
                                        <div className="resume__select w200h50">
                                            <div className="resume__name opp">1순위</div>
                                            <Dropdown
                                                placeholder="시/도 선택"
                                                options={getOptions('ResumeRegionSi')}
                                                name="resumeRegionSi1"
                                                value={payload.resumeRegionSi1 || ''}
                                                onChange={handleSelectSi}
                                                className="pt0"
                                                id="resumeRegionSi1"
                                            />
                                        </div>
                                        <div className="resume__select resume__select--bdl0 w200h50">
                                            <Dropdown
                                                placeholder="군/구"
                                                options={getOptions('ResumeRegionGu', selectedSi1, payload.resumeRegionGu1)}
                                                name="resumeRegionGu1"
                                                value={payload.resumeRegionGu1 || ''}
                                                onChange={handleChangeDropdown}
                                                className="pt0"
                                                id="resumeRegionGu1"
                                            />
                                        </div>
                                    </div>
                                    <div className="resume__flex pl40">
                                        <div className="resume__select w200h50">
                                            <div className="resume__name opp">2순위</div>
                                            <Dropdown
                                                placeholder="시/도 선택"
                                                options={getOptions('ResumeRegionSi')}
                                                name="resumeRegionSi2"
                                                value={payload.resumeRegionSi2 || ''}
                                                onChange={handleSelectSi}
                                                className="pt0"
                                            />
                                        </div>
                                        <div className="resume__select resume__select--bdl0 w200h50">
                                            <Dropdown
                                                placeholder="군/구"
                                                options={getOptions('ResumeRegionGu', selectedSi2, payload.resumeRegionGu2)}
                                                name="resumeRegionGu2"
                                                value={payload.resumeRegionGu2 || ''}
                                                onChange={handleChangeDropdown}
                                                className="pt0"
                                            />
                                        </div>
                                    </div>
                                    <div className="resume__flex pl40">
                                        <div className="resume__select w200h50">
                                            <div className="resume__name opp">3순위</div>
                                            <Dropdown
                                                placeholder="시/도 선택"
                                                options={getOptions('ResumeRegionSi')}
                                                name="resumeRegionSi3"
                                                value={payload.resumeRegionSi3 || ''}
                                                onChange={handleSelectSi}
                                                className="pt0"
                                            />
                                        </div>
                                        <div className="resume__select resume__select--bdl0 w200h50">
                                            <Dropdown
                                                placeholder="군/구"
                                                options={getOptions('ResumeRegionGu', selectedSi3, payload.resumeRegionGu3)}
                                                name="resumeRegionGu3"
                                                value={payload.resumeRegionGu3 || ''}
                                                onChange={handleChangeDropdown}
                                                className="pt0"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="resume__div">
                                    <h4 className="resume__tit3 resume__tit3--esn">희망 급여</h4>
                                    <div className="resume__check" style={{ height: '32px' }}>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                onChange={handleCheckBox}
                                                name="resumePay"
                                                checked={payload.resumePay === '001'}
                                                value="001"
                                            />
                                            <span>협의 후 결정</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                onChange={handleCheckBox}
                                                name="resumePay"
                                                checked={payload.resumePay === '002'}
                                                value="002"
                                            />
                                            <span>내규에 따름</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                onChange={handleCheckBox}
                                                name="resumePay"
                                                checked={payload.resumePay === '003'}
                                                value="003"
                                            />
                                            <span>연봉제</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                onChange={handleCheckBox}
                                                name="resumePay"
                                                checked={payload.resumePay === '999'}
                                                value="999"
                                            />
                                            <span>직접입력</span>
                                            {payload.resumePay === '999' && (
                                                <div className="resume__won">
                                                    <input
                                                        type="number"
                                                        className="resume__woninput"
                                                        onChange={handleChange}
                                                        name="resumePayEtc"
                                                        value={payload.resumePayEtc || ''}
                                                    />
                                                    <span>만원</span>
                                                </div>
                                            )}
                                        </label>
                                    </div>
                                </div>
                                <div className="resume__div">
                                    <h4 className="resume__tit3 resume__tit3--esn">희망 직급</h4>
                                    <div className="resume__check">
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                value="001"
                                                onChange={handleCheckBox}
                                                name="resumePosition"
                                                checked={(payload.resumePosition ?? '').split(',').includes('001')}
                                            />
                                            <span>팀장</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                value="002"
                                                onChange={handleCheckBox}
                                                name="resumePosition"
                                                checked={(payload.resumePosition ?? '').split(',').includes('002')}
                                            />
                                            <span>실장</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                value="003"
                                                onChange={handleCheckBox}
                                                name="resumePosition"
                                                checked={(payload.resumePosition ?? '').split(',').includes('003')}
                                            />
                                            <span>스탭</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="checkbox"
                                                className="resume__checkbox"
                                                value="999"
                                                onChange={handleCheckBox}
                                                name="resumePosition"
                                                checked={(payload.resumePosition ?? '').split(',').includes('999')}
                                            />
                                            <span>무관</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="resume__div">
                                    <h4 className="resume__tit3 resume__tit3--esn">희망 근무요일</h4>
                                    <div className="resume__check">
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeDay"
                                                value="001"
                                                checked={payload.resumeDay === '001'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>월~금(주5일)</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeDay"
                                                value="004"
                                                checked={payload.resumeDay === '004'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>월~토(주 6일)</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeDay"
                                                value="002"
                                                checked={payload.resumeDay === '002'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>월~금(주40시간)</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeDay"
                                                value="003"
                                                checked={payload.resumeDay === '003'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>월~토(토요일격주휴무)</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeDay"
                                                value="999"
                                                checked={payload.resumeDay === '999'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>직접입력</span>
                                            {payload.resumeDay === '999' && (
                                                <div className="resume__day">
                                                    <input
                                                        type="text"
                                                        className="resume__dayinput"
                                                        name="resumeDayEtc"
                                                        onChange={handleChange}
                                                        value={payload.resumeDayEtc || ''}
                                                    />
                                                </div>
                                            )}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="resume__tit-box">
                                <h4 className="resume__tit2">
                                    학력사항<span>*</span>
                                </h4>
                            </div>
                            <div className="resume__block">
                                <div className="resume__div">
                                    <fieldset className="resume__check">
                                        <label className="resume__label  pointer">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeGrade"
                                                value="001"
                                                checked={payload.resumeGrade === '001'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>고등학교 졸업</span>
                                        </label>
                                        <label className="resume__label pointer">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeGrade"
                                                value="009"
                                                checked={payload.resumeGrade === '009'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>전문대/대학 졸업</span>
                                        </label>
                                        <label className="resume__label pointer">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeGrade"
                                                value="013"
                                                checked={payload.resumeGrade === '013'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>대학원 이상 졸업</span>
                                        </label>
                                    </fieldset>
                                </div>

                                <ul className="resume__list2">
                                    <li className="resume__item2">
                                        <div className="resume__grid3">
                                            <div className="resume__div">
                                                <div className="resume__select resume__select--hideDd">
                                                    <div className="resume__name">학교 구분</div>
                                                    <Dropdown
                                                        placeholder="고등학교 졸업"
                                                        options={[{ value: '001', option: '' }]}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="resume__input--school">
                                                <div className="resume__input-box resume__input-box--bdl0">
                                                    <label htmlFor="school-1">학교명</label>
                                                    <input
                                                        className="resume__input"
                                                        type="text"
                                                        id="school-1"
                                                        name="schoolName1"
                                                        value={formResumeSchoolInfo.schoolName[0] || ''}
                                                        onChange={handleInputChangeSchoolInfo}
                                                    />
                                                </div>
                                                <span>고등학교</span>
                                            </div>
                                        </div>
                                        <div className="resume__grid4">
                                            <div className="resume__input-box">
                                                <label htmlFor="grdtn-1">입학 연도</label>
                                                <DatePicker
                                                    onChange={(date) =>
                                                        handleDateChangeSchoolInfo(date, 'yearMonthStart1')
                                                    }
                                                    locale={'ko'}
                                                    placeholderText={'YYYY-MM'}
                                                    dateFormat={'yyyy-MM'}
                                                    showMonthYearPicker
                                                    name="yearMonthStart1"
                                                    selected={parseYearMonth(
                                                        `${formResumeSchoolInfo.yearStart[0] || ''}${formResumeSchoolInfo.monthStart[0]
                                                            ? '-' + formResumeSchoolInfo.monthStart[0]
                                                            : ''
                                                        }`,
                                                    )}
                                                    className="resume__input"
                                                    customInput={<CustomInputDatePicker />}
                                                />
                                            </div>

                                            <div className="resume__input-box resume__input-box--bdl0">
                                                <label htmlFor="grdtn-2">졸업 연도</label>
                                                <DatePicker
                                                    onChange={(date) =>
                                                        handleDateChangeSchoolInfo(date, 'yearMonthEnd1')
                                                    }
                                                    locale={'ko'}
                                                    placeholderText={'YYYY-MM'}
                                                    dateFormat={'yyyy-MM'}
                                                    showMonthYearPicker
                                                    name="yearMonthEnd1"
                                                    selected={parseYearMonth(
                                                        `${formResumeSchoolInfo.yearEnd[0] || ''}${formResumeSchoolInfo.monthEnd[0]
                                                            ? '-' + formResumeSchoolInfo.monthEnd[0]
                                                            : ''
                                                        }`,
                                                    )}
                                                    minDate={
                                                        parseYearMonth(
                                                            `${formResumeSchoolInfo.yearStart[0] || ''}${formResumeSchoolInfo.monthStart[0]
                                                                ? '-' + formResumeSchoolInfo.monthStart[0]
                                                                : ''
                                                            }`,
                                                        ) || undefined
                                                    }
                                                    className="resume__input"
                                                    customInput={<CustomInputDatePicker />}
                                                />
                                            </div>

                                            <div
                                                className="resume__select resume__select--bdl0"
                                                style={{ display: 'flex', alignItems: 'center' }}
                                            >
                                                <ul>
                                                    <Checkbox
                                                        options={[
                                                            {
                                                                id: 'status1_checkbox',
                                                                value: '대입검정고시',
                                                                label: '대입검정고시',
                                                            },
                                                        ]}
                                                        name="status1"
                                                        onChange={() => {
                                                            handleChangeSchoolInfo(
                                                                formResumeSchoolInfo.status[0] === '대입검정고시'
                                                                    ? ''
                                                                    : '대입검정고시',
                                                                'status1',
                                                            );
                                                        }}
                                                        id="status1"
                                                        checkedValues={formResumeSchoolInfo.status[0]}
                                                    />
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    {(payload.resumeGrade === '009' || payload.resumeGrade === '013') && (
                                        <>
                                            <li className="resume__item2">
                                                <div className="resume__grid3">
                                                    <div className="resume__select">
                                                        <div className="resume__name">학교 구분</div>
                                                        <Dropdown
                                                            placeholder="학교 구분"
                                                            options={getOptions('Grade1')}
                                                            name="grade2"
                                                            value={
                                                                payload.resumeGrade === '001'
                                                                    ? ''
                                                                    : formResumeSchoolInfo.grade[1] || ''
                                                            }
                                                            onChange={handleChangeSchoolInfo}
                                                            disabled={payload.resumeGrade === '001'}
                                                            className="max-content"
                                                            id="grade2"
                                                        />
                                                    </div>
                                                    <div className="resume__input--school">
                                                        <div className="resume__input-box resume__input-box--bdl0 ">
                                                            <label htmlFor="school-2">학교명</label>
                                                            <input
                                                                className="resume__input"
                                                                type="text"
                                                                id="school-2"
                                                                name="schoolName2"
                                                                value={
                                                                    payload.resumeGrade === '001'
                                                                        ? ''
                                                                        : formResumeSchoolInfo.schoolName[1] || ''
                                                                }
                                                                onChange={handleInputChangeSchoolInfo}
                                                                disabled={payload.resumeGrade === '001'}
                                                            />
                                                        </div>
                                                        <span>대학교</span>
                                                    </div>
                                                </div>
                                                <div className="resume__grid4">
                                                    <div className="resume__input-box">
                                                        <label htmlFor="mtcltn-1">입학 연도</label>
                                                        <DatePicker
                                                            onChange={(date) =>
                                                                handleDateChangeSchoolInfo(date, 'yearMonthStart2')
                                                            }
                                                            locale={'ko'}
                                                            placeholderText={'YYYY-MM'}
                                                            dateFormat={'yyyy-MM'}
                                                            showMonthYearPicker
                                                            name="yearMonthStart2"
                                                            selected={
                                                                payload.resumeGrade === '001'
                                                                    ? null
                                                                    : parseYearMonth(
                                                                        `${formResumeSchoolInfo.yearStart[1] || ''}${formResumeSchoolInfo.monthStart[1]
                                                                            ? '-' + formResumeSchoolInfo.monthStart[1]
                                                                            : ''
                                                                        }`,
                                                                    )
                                                            }
                                                            className="resume__input"
                                                            disabled={payload.resumeGrade === '001'}
                                                            customInput={<CustomInputDatePicker />}
                                                        />
                                                    </div>
                                                    <div className="resume__input-box resume__input-box--bdl0">
                                                        <label htmlFor="grdtn-2">졸업 연도</label>
                                                        <DatePicker
                                                            onChange={(date) =>
                                                                handleDateChangeSchoolInfo(date, 'yearMonthEnd2')
                                                            }
                                                            locale={'ko'}
                                                            placeholderText={
                                                                formResumeSchoolInfo.status[1] === '재학'
                                                                    ? ''
                                                                    : 'YYYY-MM'
                                                            }
                                                            dateFormat={'yyyy-MM'}
                                                            showMonthYearPicker
                                                            name="yearMonthEnd2"
                                                            selected={
                                                                payload.resumeGrade === '001'
                                                                    ? null
                                                                    : parseYearMonth(
                                                                        `${formResumeSchoolInfo.yearEnd[1] || ''}${formResumeSchoolInfo.monthEnd[1]
                                                                            ? '-' + formResumeSchoolInfo.monthEnd[1]
                                                                            : ''
                                                                        }`,
                                                                    )
                                                            }
                                                            className="resume__input"
                                                            disabled={payload.resumeGrade === '001'}
                                                            customInput={<CustomInputDatePicker />}
                                                        />
                                                    </div>
                                                    <div className="resume__select resume__select--bdl0">
                                                        <div className="resume__name">졸업 상태</div>
                                                        <Dropdown
                                                            placeholder="졸업 상태"
                                                            options={[
                                                                { value: '졸업', option: '졸업' },
                                                                { value: '재학', option: '재학' },
                                                                { value: '수료', option: '수료' },
                                                            ]}
                                                            name="status2"
                                                            value={
                                                                payload.resumeGrade === '001'
                                                                    ? ''
                                                                    : formResumeSchoolInfo.status[1] || ''
                                                            }
                                                            onChange={handleChangeSchoolInfo}
                                                            disabled={payload.resumeGrade === '001'}
                                                            id="status2"
                                                            className="noBorderLeft"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="resume__item2">
                                                <div className="resume__grid3 resume__grid3--one">
                                                    <div className="resume__input-box">
                                                        <label htmlFor="major-1">전공명</label>
                                                        <input
                                                            className="resume__input"
                                                            type="text"
                                                            id="major-1"
                                                            name="major2"
                                                            value={
                                                                payload.resumeGrade === '001'
                                                                    ? ''
                                                                    : formResumeSchoolInfo.major[1] || ''
                                                            }
                                                            onChange={handleInputChangeSchoolInfo}
                                                            disabled={payload.resumeGrade === '001'}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="resume__grid4">
                                                    <div className="resume__input-box">
                                                        <label htmlFor="grade-1">학점</label>
                                                        <input
                                                            className="resume__input"
                                                            type="text"
                                                            id="grade-1"
                                                            name="gpa2"
                                                            value={
                                                                payload.resumeGrade === '001'
                                                                    ? ''
                                                                    : formResumeSchoolInfo.gpa[1] || ''
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^[0-9.]*$/.test(value)) {
                                                                    handleInputChangeSchoolInfo(e);
                                                                }
                                                            }}
                                                            disabled={payload.resumeGrade === '001'}
                                                        />
                                                    </div>
                                                    <div className="resume__select resume__select--bdl0">
                                                        <div className="resume__name">총점</div>
                                                        <Dropdown
                                                            placeholder="4.5"
                                                            options={[
                                                                { value: '4.5', option: '4.5' },
                                                                { value: '4.3', option: '4.3' },
                                                                { value: '4.0', option: '4.0' },
                                                                { value: '100', option: '100' },
                                                            ]}
                                                            name="gpaScale2"
                                                            value={
                                                                payload.resumeGrade === '001'
                                                                    ? '4.0'
                                                                    : formResumeSchoolInfo.gpaScale[1] || ''
                                                            }
                                                            onChange={handleChangeSchoolInfo}
                                                            disabled={payload.resumeGrade === '001'}
                                                            className="noBorderLeft"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                        </>
                                    )}
                                    {payload.resumeGrade === '013' && (
                                        <>
                                            <li className="resume__item2">
                                                <div className="resume__grid3">
                                                    <div className="resume__select">
                                                        <div className="resume__name">학교 구분</div>
                                                        <Dropdown
                                                            placeholder="학교 구분"
                                                            options={getOptions('Grade2')}
                                                            name="grade3"
                                                            value={
                                                                payload.resumeGrade === '001' ||
                                                                    payload.resumeGrade === '009'
                                                                    ? ''
                                                                    : formResumeSchoolInfo.grade[2] || ''
                                                            }
                                                            onChange={handleChangeSchoolInfo}
                                                            disabled={
                                                                payload.resumeGrade === '001' ||
                                                                payload.resumeGrade === '009'
                                                            }
                                                            className="max-content"
                                                            id="grade3"
                                                        />
                                                    </div>
                                                    <div className="resume__input--school">
                                                        <div className="resume__input-box resume__input-box--bdl0">
                                                            <label htmlFor="school-3">학교명</label>
                                                            <input
                                                                className="resume__input"
                                                                type="text"
                                                                id="school-3"
                                                                name="schoolName3"
                                                                value={
                                                                    payload.resumeGrade === '001' ||
                                                                        payload.resumeGrade === '009'
                                                                        ? ''
                                                                        : formResumeSchoolInfo.schoolName[2] || ''
                                                                }
                                                                onChange={handleInputChangeSchoolInfo}
                                                                disabled={
                                                                    payload.resumeGrade === '001' ||
                                                                    payload.resumeGrade === '009'
                                                                }
                                                            />
                                                        </div>
                                                        <span>대학원</span>
                                                    </div>
                                                </div>
                                                <div className="resume__grid4">
                                                    <div className="resume__input-box">
                                                        <label htmlFor="mtcltn-2">입학 연도</label>
                                                        <DatePicker
                                                            onChange={(date) =>
                                                                handleDateChangeSchoolInfo(date, 'yearMonthStart3')
                                                            }
                                                            locale={'ko'}
                                                            placeholderText={'YYYY-MM'}
                                                            dateFormat={'yyyy-MM'}
                                                            showMonthYearPicker
                                                            name="yearMonthStart3"
                                                            selected={
                                                                payload.resumeGrade === '001' ||
                                                                    payload.resumeGrade === '009'
                                                                    ? null
                                                                    : parseYearMonth(
                                                                        `${formResumeSchoolInfo.yearStart[2] || ''}${formResumeSchoolInfo.monthStart[2]
                                                                            ? '-' + formResumeSchoolInfo.monthStart[2]
                                                                            : ''
                                                                        }`,
                                                                    )
                                                            }
                                                            className="resume__input"
                                                            disabled={
                                                                payload.resumeGrade === '001' ||
                                                                payload.resumeGrade === '009'
                                                            }
                                                            customInput={<CustomInputDatePicker />}
                                                        />
                                                    </div>
                                                    <div className="resume__input-box resume__input-box--bdl0">
                                                        <label htmlFor="grdtn-3">졸업 연도</label>
                                                        <DatePicker
                                                            onChange={(date) =>
                                                                handleDateChangeSchoolInfo(date, 'yearMonthEnd3')
                                                            }
                                                            locale={'ko'}
                                                            placeholderText={
                                                                formResumeSchoolInfo.status[2] === '재학'
                                                                    ? ''
                                                                    : 'YYYY-MM'
                                                            }
                                                            dateFormat={'yyyy-MM'}
                                                            showMonthYearPicker
                                                            name="yearMonthEnd3"
                                                            selected={
                                                                payload.resumeGrade === '001' ||
                                                                    payload.resumeGrade === '009'
                                                                    ? null
                                                                    : parseYearMonth(
                                                                        `${formResumeSchoolInfo.yearEnd[2] || ''}${formResumeSchoolInfo.monthEnd[2]
                                                                            ? '-' + formResumeSchoolInfo.monthEnd[2]
                                                                            : ''
                                                                        }`,
                                                                    )
                                                            }
                                                            className="resume__input"
                                                            disabled={
                                                                payload.resumeGrade === '001' ||
                                                                payload.resumeGrade === '009'
                                                            }
                                                            customInput={<CustomInputDatePicker />}
                                                        />
                                                    </div>
                                                    <div className="resume__select resume__select--bdl0">
                                                        <div className="resume__name">졸업 상태</div>
                                                        <Dropdown
                                                            placeholder="졸업 상태"
                                                            options={[
                                                                { value: '졸업', option: '졸업' },
                                                                { value: '재학', option: '재학' },
                                                                { value: '수료', option: '수료' },
                                                            ]}
                                                            name="status3"
                                                            value={
                                                                payload.resumeGrade === '001'
                                                                    ? ''
                                                                    : formResumeSchoolInfo.status[2] || ''
                                                            }
                                                            onChange={handleChangeSchoolInfo}
                                                            disabled={
                                                                payload.resumeGrade === '001' ||
                                                                payload.resumeGrade === '009'
                                                            }
                                                            id="status3"
                                                            className="noBorderLeft"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="resume__item2">
                                                <div className="resume__grid3 resume__grid3--one">
                                                    <div className="resume__input-box">
                                                        <label htmlFor="major-2">전공명</label>
                                                        <input
                                                            className="resume__input"
                                                            type="text"
                                                            id="major-2"
                                                            name="major3"
                                                            value={
                                                                payload.resumeGrade === '001' ||
                                                                    payload.resumeGrade === '009'
                                                                    ? ''
                                                                    : formResumeSchoolInfo.major[2] || ''
                                                            }
                                                            onChange={handleInputChangeSchoolInfo}
                                                            disabled={
                                                                payload.resumeGrade === '001' ||
                                                                payload.resumeGrade === '009'
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="resume__grid4">
                                                    <div className="resume__input-box">
                                                        <label htmlFor="grade-2">학점</label>
                                                        <input
                                                            className="resume__input"
                                                            type="text"
                                                            id="grade-2"
                                                            name="gpa3"
                                                            value={
                                                                payload.resumeGrade === '001' ||
                                                                    payload.resumeGrade === '009'
                                                                    ? ''
                                                                    : formResumeSchoolInfo.gpa[2] || ''
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^[0-9.]*$/.test(value)) {
                                                                    handleInputChangeSchoolInfo(e);
                                                                }
                                                            }}
                                                            disabled={
                                                                payload.resumeGrade === '001' ||
                                                                payload.resumeGrade === '009'
                                                            }
                                                        />
                                                    </div>
                                                    <div className="resume__select resume__select--bdl0">
                                                        <div className="resume__name">총점</div>
                                                        <Dropdown
                                                            placeholder="4.5"
                                                            options={[
                                                                { value: '4.5', option: '4.5' },
                                                                { value: '4.3', option: '4.3' },
                                                                { value: '4.0', option: '4.0' },
                                                                { value: '100', option: '100' },
                                                            ]}
                                                            name="gpaScale3"
                                                            value={
                                                                payload.resumeGrade === '001' ||
                                                                    payload.resumeGrade === '009'
                                                                    ? '4.0'
                                                                    : formResumeSchoolInfo.gpaScale[2] || ''
                                                            }
                                                            onChange={handleChangeSchoolInfo}
                                                            disabled={
                                                                payload.resumeGrade === '001' ||
                                                                payload.resumeGrade === '009'
                                                            }
                                                            className="noBorderLeft"
                                                        />
                                                    </div>
                                                </div>
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </div>
                            <div className="resume__tit-box">
                                <h4 className="resume__tit2">경력사항</h4>
                            </div>
                            <div className="resume__block resume__block--pdlr0">
                                <div className="resume__div resume__div--pdlr20">
                                    <div className="resume__check resume__check--gap75">
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeCareer"
                                                value="001"
                                                checked={payload.resumeCareer === '001'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>신입</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeCareer"
                                                value="009"
                                                checked={payload.resumeCareer === '009'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>경력</span>
                                        </label>
                                    </div>
                                </div>
                                {payload.resumeCareer === '009' && (
                                    <>
                                        <ul className="resume__list">
                                            {careerList.map((item, index) => (
                                                <li className="resume__item" key={index + 1}>
                                                    <button
                                                        type="button"
                                                        className="resume__delete-btn"
                                                        onClick={() => handleDeleteItem(index, setCareerList)}
                                                        disabled={payload.resumeCareer === '001'}
                                                    />
                                                    <div className="resume__grid2">
                                                        <div className="resume__input-box">
                                                            <label htmlFor={`insNm-${index + 1}`}>치과명</label>
                                                            <input
                                                                className="resume__input"
                                                                type="text"
                                                                id={`insNm-${index + 1}`}
                                                                name={`businessName${index + 1}`}
                                                                value={item[`businessName${index + 1}`] || ''}
                                                                disabled={payload.resumeCareer === '001'}
                                                                onChange={(e) =>
                                                                    handleInputChange(e, index, setCareerList)
                                                                }
                                                            />
                                                        </div>
                                                        <div className="resume__rt">
                                                            <div className="resume__input-box">
                                                                <label htmlFor={`careerYearMonthStart${index + 1}`}>
                                                                    입사 연월
                                                                </label>
                                                                <DatePicker
                                                                    onChange={(date) =>
                                                                        handleDateChange(
                                                                            `careerYearMonthStart${index + 1}`,
                                                                            date,
                                                                            index,
                                                                            setCareerList,
                                                                        )
                                                                    }
                                                                    id={`careerYearMonthStart${index + 1}`}
                                                                    locale={'ko'}
                                                                    placeholderText={'YYYY-MM'}
                                                                    dateFormat={'yyyy-MM'}
                                                                    showMonthYearPicker
                                                                    name={`careerYearMonthStart${index + 1}`}
                                                                    selected={parseYearMonth(
                                                                        item[`careerYearMonthStart${index + 1}`],
                                                                    )}
                                                                    className="resume__input"
                                                                    disabled={payload.resumeCareer === '001'}
                                                                    customInput={<CustomInputDatePicker />}
                                                                />
                                                            </div>
                                                            <div className="resume__input-box resume__input-box--bdl0">
                                                                <label htmlFor={`careerYearMonthEnd${index + 1}`}>
                                                                    퇴사 연월
                                                                </label>
                                                                <DatePicker
                                                                    onChange={(date) =>
                                                                        handleCareerEndDateChange(index, date)
                                                                    }
                                                                    id={`careerYearMonthEnd${index + 1}`}
                                                                    locale={'ko'}
                                                                    placeholderText={'YYYY-MM'}
                                                                    dateFormat={'yyyy-MM'}
                                                                    showMonthYearPicker
                                                                    name={`careerYearMonthEnd${index + 1}`}
                                                                    selected={
                                                                        item[`working${index + 1}`] === 'N' ||
                                                                            item[`working${index + 1}`] === undefined
                                                                            ? parseYearMonth(
                                                                                item[`careerYearMonthEnd${index + 1}`],
                                                                            )
                                                                            : null
                                                                    }
                                                                    className="resume__input"
                                                                    minDate={
                                                                        parseYearMonth(
                                                                            item[`careerYearMonthStart${index + 1}`],
                                                                        ) || undefined
                                                                    }
                                                                    customInput={<CustomInputDatePicker />}
                                                                />
                                                            </div>
                                                            <div className="resume__radio-box">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`working-${index + 1}`}
                                                                    name={`working${index + 1}`}
                                                                    checked={item[`working${index + 1}`] === 'Y'}
                                                                    disabled={payload.resumeCareer === '001'}
                                                                    onChange={() => handleToggleWorking(index)}
                                                                />
                                                                <label htmlFor={`working-${index + 1}`}>재직중</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="resume__grid2">
                                                        <div className="resume__rt">
                                                            <div className="resume__select">
                                                                <div className="resume__name">근무지역</div>
                                                                <Dropdown
                                                                    id={`careerSi${index + 1}`}
                                                                    placeholder="근무지역"
                                                                    options={getOptions('ResumeRegionSi')}
                                                                    name={`careerSi${index + 1}`}
                                                                    disabled={payload.resumeCareer === '001'}
                                                                    value={
                                                                        payload.resumeCareer === '001'
                                                                            ? ''
                                                                            : item[`careerSi${index + 1}`] || ''
                                                                    }
                                                                    onChange={(selectedValue) =>
                                                                        handleChangeInfo(
                                                                            `careerSi${index + 1}`,
                                                                            selectedValue,
                                                                            index,
                                                                            setCareerList,
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="resume__select resume__select--bdl0">
                                                                <div className="resume__name">직급/직책</div>
                                                                <Dropdown
                                                                    id={`position${index + 1}`}
                                                                    placeholder="직급/직책"
                                                                    options={[
                                                                        { value: '팀장', option: '팀장' },
                                                                        { value: '실장', option: '실장' },
                                                                        { value: '스탭', option: '스탭' },
                                                                        { value: '기타', option: '기타' },
                                                                    ]}
                                                                    name={`position${index + 1}`}
                                                                    value={
                                                                        payload.resumeCareer === '001'
                                                                            ? ''
                                                                            : item[`position${index + 1}`] || ''
                                                                    }
                                                                    disabled={payload.resumeCareer === '001'}
                                                                    onChange={(selectedValue) =>
                                                                        handleChangeInfo(
                                                                            `position${index + 1}`,
                                                                            selectedValue,
                                                                            index,
                                                                            setCareerList,
                                                                        )
                                                                    }
                                                                    className="noBorderLeft"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="resume__input-box">
                                                            <label htmlFor={`reasonsLeave-${index + 1}`}>
                                                                퇴사 사유
                                                            </label>
                                                            <input
                                                                className="resume__input"
                                                                type="text"
                                                                name={`reasonsLeave${index + 1}`}
                                                                value={item[`reasonsLeave${index + 1}`] || ''}
                                                                disabled={payload.resumeCareer === '001'}
                                                                onChange={(e) =>
                                                                    handleInputChange(e, index, setCareerList)
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="resume__input-box resume__input-box--mt10 resume__input-box--auto">
                                                        <label htmlFor={`rsp-${index + 1}`}>담당업무</label>
                                                        <input
                                                            id={`rsp-${index + 1}`}
                                                            className="resume__input"
                                                            name={`respon${index + 1}`}
                                                            value={item[`respon${index + 1}`] || ''}
                                                            disabled={payload.resumeCareer === '001'}
                                                            onChange={(e) => handleInputChange(e, index, setCareerList)}
                                                        />
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>

                                        <button type="button" className="resume__add" onClick={handleAddCareer}>
                                            <div className="resume__add-icon" />
                                            추가
                                        </button>
                                        <div className="resume__flex resume__flex--pd20 resume__flex--mt20">
                                            <div className="resume__input-box">
                                                <label htmlFor="career">총 경력 (년)</label>
                                                <input
                                                    className="resume__input"
                                                    type="number"
                                                    id="career"
                                                    name="resumeCareerYear"
                                                    value={calculateExperience(careerList)}
                                                    disabled={payload.resumeCareer === '001'}
                                                    onChange={handleChange}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="resume__flex resume__flex--pd20">
                                            <div className="resume__input-box resume__input-box--auto">
                                                <label htmlFor="crrDsc">
                                                    기타 경력사항 및 기술서 300자 이내 (생략가능)
                                                </label>
                                                <textarea
                                                    id="crrDsc"
                                                    className="resume__textarea resume__textarea--h80"
                                                    name="resumeCareerEtc"
                                                    value={payload.resumeCareerEtc || ''}
                                                    disabled={payload.resumeCareer === '001'}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* resume license info */}
                            <div className="resume__tit-box">
                                <h4 className="resume__tit2">자격/면허정보</h4>
                            </div>
                            <div className="resume__block resume__block--pdlr0">
                                <div className="resume__div resume__div--pdlr20">
                                    <div className="resume__check resume__check--gap75">
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeLicenseYn"
                                                value="N"
                                                checked={payload.resumeLicenseYn === 'N'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>없음</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeLicenseYn"
                                                value="Y"
                                                checked={payload.resumeLicenseYn === 'Y'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>보유</span>
                                        </label>
                                    </div>
                                </div>
                                {payload.resumeLicenseYn === 'Y' && (
                                    <>
                                        <ul className="resume__list">
                                            {licenseList.map((item, index) => (
                                                <li className="resume__item" key={'resumeLicense' + index + 1}>
                                                    <button
                                                        type="button"
                                                        className="resume__delete-btn"
                                                        disabled={payload.resumeLicenseYn === 'N'}
                                                        onClick={() => handleDeleteItem(index, setLicenseList)}
                                                    />
                                                    <div className="resume__grid5">
                                                        <div className="resume__select">
                                                            <div className="resume__name">구분</div>
                                                            <Dropdown
                                                                id={`licenseType${index + 1}`}
                                                                placeholder="구분"
                                                                options={[
                                                                    { value: '자격', option: '자격' },
                                                                    { value: '면허', option: '면허' },
                                                                ]}
                                                                name={`licenseType${index + 1}`}
                                                                disabled={payload.resumeLicenseYn === 'N'}
                                                                value={
                                                                    payload.resumeLicenseYn === 'N'
                                                                        ? ''
                                                                        : item[`licenseType${index + 1}`] || ''
                                                                }
                                                                onChange={(selectedValue) =>
                                                                    handleChangeInfo(
                                                                        `licenseType${index + 1}`,
                                                                        selectedValue,
                                                                        index,
                                                                        setLicenseList,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="resume__input-box">
                                                            <label htmlFor={`licenseName-${index + 1}`}>
                                                                자격/면허명
                                                            </label>
                                                            <input
                                                                className="resume__input"
                                                                type="text"
                                                                id={`licenseName-${index + 1}`}
                                                                disabled={payload.resumeLicenseYn === 'N'}
                                                                name={`licenseName${index + 1}`}
                                                                value={item[`licenseName${index + 1}`] || ''}
                                                                onChange={(e) =>
                                                                    handleInputChange(e, index, setLicenseList)
                                                                }
                                                            />
                                                        </div>
                                                        <div className="resume__input-box">
                                                            <label htmlFor={`licenseNumber-${index + 1}`}>
                                                                자격/면허번호
                                                            </label>
                                                            <input
                                                                className="resume__input"
                                                                type="text"
                                                                id={`licenseNumber-${index + 1}`}
                                                                disabled={payload.resumeLicenseYn === 'N'}
                                                                name={`licenseNumber${index + 1}`}
                                                                value={item[`licenseNumber${index + 1}`] || ''}
                                                                onChange={(e) =>
                                                                    handleInputChange(e, index, setLicenseList)
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="resume__grid6">
                                                        <div className="resume__input-box">
                                                            <label htmlFor={`pblc-${index + 1}`}>발행처</label>
                                                            <input
                                                                className="resume__input"
                                                                type="text"
                                                                id={`pblc-${index + 1}`}
                                                                disabled={payload.resumeLicenseYn === 'N'}
                                                                name={`licensePlace${index + 1}`}
                                                                value={item[`licensePlace${index + 1}`] || ''}
                                                                onChange={(e) =>
                                                                    handleInputChange(e, index, setLicenseList)
                                                                }
                                                            />
                                                        </div>
                                                        <div className="resume__input-box">
                                                            <label htmlFor={`licenseYearMonth${index + 1}`}>
                                                                취득 연월
                                                            </label>
                                                            <DatePicker
                                                                onChange={(date) =>
                                                                    handleDateChange(
                                                                        `licenseYearMonth${index + 1}`,
                                                                        date,
                                                                        index,
                                                                        setLicenseList,
                                                                    )
                                                                }
                                                                id={`licenseYearMonth${index + 1}`}
                                                                locale={'ko'}
                                                                placeholderText={'YYYY-MM'}
                                                                dateFormat={'yyyy-MM'}
                                                                showMonthYearPicker
                                                                name={`licenseYearMonth${index + 1}`}
                                                                selected={parseYearMonth(
                                                                    item[`licenseYearMonth${index + 1}`],
                                                                )}
                                                                className="resume__input"
                                                                disabled={payload.resumeLicenseYn === 'N'}
                                                                customInput={<CustomInputDatePicker />}
                                                            />
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>

                                        <button
                                            type="button"
                                            className="resume__add"
                                            disabled={payload.resumeLicenseYn === 'N'}
                                            onClick={handleAddLicense}
                                        >
                                            <div className="resume__add-icon" />
                                            추가
                                        </button>
                                    </>
                                )}
                            </div>

                            {/* resume active info */}
                            <div className="resume__tit-box">
                                <h4 className="resume__tit2">기타활동/사회경험</h4>
                            </div>
                            <div className="resume__block resume__block--pdlr0">
                                <div className="resume__div resume__div--pdlr20">
                                    <div className="resume__check resume__check--gap75">
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeActiveYn"
                                                value="N"
                                                checked={payload.resumeActiveYn === 'N'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>없음</span>
                                        </label>
                                        <label className="resume__label">
                                            <input
                                                type="radio"
                                                className="resume__radio"
                                                name="resumeActiveYn"
                                                value="Y"
                                                checked={payload.resumeActiveYn === 'Y'}
                                                onChange={handleCheckBox}
                                            />
                                            <span>보유</span>
                                        </label>
                                    </div>
                                </div>
                                {payload.resumeActiveYn === 'Y' && (
                                    <>
                                        <ul className="resume__list">
                                            {activeResumeList.map((item, index) => (
                                                <li className="resume__item" key={'activeResume' + index + 1}>
                                                    <button
                                                        type="button"
                                                        className="resume__delete-btn"
                                                        disabled={payload.resumeActiveYn === 'N'}
                                                        onClick={() => handleDeleteItem(index, setActiveResumeList)}
                                                    />
                                                    <div className="resume__grid5">
                                                        <div className="resume__select">
                                                            <div className="resume__name">활동 종류</div>
                                                            <Dropdown
                                                                id={`type${index + 1}`}
                                                                placeholder="활동 종류"
                                                                options={[
                                                                    { value: '교육', option: '교육' },
                                                                    { value: '학원', option: '학원' },
                                                                    { value: '인턴', option: '인턴' },
                                                                    { value: '아르바이트', option: '아르바이트' },
                                                                    { value: '동아리', option: '동아리' },
                                                                    { value: '자원봉사', option: '자원봉사' },
                                                                    { value: '사회활동', option: '사회활동' },
                                                                    { value: '교내활동', option: '교내활동' },
                                                                    { value: '수행과제', option: '수행과제' },
                                                                    { value: '해외연수', option: '해외연수' },
                                                                    { value: '기타', option: '기타' },
                                                                ]}
                                                                name={`type${index + 1}`}
                                                                value={
                                                                    payload.resumeActiveYn === 'N'
                                                                        ? ''
                                                                        : item[`type${index + 1}`] || ''
                                                                }
                                                                disabled={payload.resumeActiveYn === 'N'}
                                                                onChange={(selectedValue) =>
                                                                    handleChangeInfo(
                                                                        `type${index + 1}`,
                                                                        selectedValue,
                                                                        index,
                                                                        setActiveResumeList,
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="resume__input-box">
                                                            <label htmlFor={`place-${index + 1}`}>기관/장소</label>
                                                            <input
                                                                className="resume__input"
                                                                type="text"
                                                                id={`place-${index + 1}`}
                                                                name={`place${index + 1}`}
                                                                value={item[`place${index + 1}`] || ''}
                                                                disabled={payload.resumeActiveYn === 'N'}
                                                                onChange={(e) =>
                                                                    handleInputChange(e, index, setActiveResumeList)
                                                                }
                                                            />
                                                        </div>
                                                        <div className="resume__flex">
                                                            <div className="resume__input-box">
                                                                <label htmlFor={`activeYearMonthStart${index + 1}`}>
                                                                    시작 연월
                                                                </label>
                                                                <DatePicker
                                                                    onChange={(date) =>
                                                                        handleDateChange(
                                                                            `activeYearMonthStart${index + 1}`,
                                                                            date,
                                                                            index,
                                                                            setActiveResumeList,
                                                                        )
                                                                    }
                                                                    id={`activeYearMonthStart${index + 1}`}
                                                                    locale={'ko'}
                                                                    placeholderText={'YYYY-MM'}
                                                                    dateFormat={'yyyy-MM'}
                                                                    showMonthYearPicker
                                                                    name={`activeYearMonthStart${index + 1}`}
                                                                    selected={parseYearMonth(
                                                                        item[`activeYearMonthStart${index + 1}`],
                                                                    )}
                                                                    className="resume__input"
                                                                    disabled={payload.resumeActiveYn === 'N'}
                                                                    customInput={<CustomInputDatePicker />}
                                                                />
                                                            </div>
                                                            <div className="resume__input-box resume__input-box--bdl0">
                                                                <label htmlFor={`endDate-${index + 1}`}>
                                                                    종료 연월
                                                                </label>
                                                                <DatePicker
                                                                    onChange={(date) =>
                                                                        handleDateChange(
                                                                            `activeYearMonthEnd${index + 1}`,
                                                                            date,
                                                                            index,
                                                                            setActiveResumeList,
                                                                        )
                                                                    }
                                                                    id={`activeYearMonthEnd${index + 1}`}
                                                                    locale={'ko'}
                                                                    placeholderText={'YYYY-MM'}
                                                                    dateFormat={'yyyy-MM'}
                                                                    showMonthYearPicker
                                                                    name={`activeYearMonthEnd${index + 1}`}
                                                                    selected={parseYearMonth(
                                                                        item[`activeYearMonthEnd${index + 1}`],
                                                                    )}
                                                                    className="resume__input"
                                                                    minDate={
                                                                        parseYearMonth(
                                                                            item[`activeYearMonthStart${index + 1}`],
                                                                        ) || undefined
                                                                    }
                                                                    disabled={payload.resumeActiveYn === 'N'}
                                                                    customInput={<CustomInputDatePicker />}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="resume__grid7">
                                                        <div className="resume__input-box resume__input-box--mt10 resume__input-box--auto">
                                                            <label htmlFor={`activity-${index + 1}`}>
                                                                활동 내용(300자 이내)
                                                            </label>
                                                            <textarea
                                                                id={`activity-${index + 1}`}
                                                                className="resume__textarea"
                                                                name={`content${index + 1}`}
                                                                value={item[`content${index + 1}`] || ''}
                                                                disabled={payload.resumeActiveYn === 'N'}
                                                                onChange={(e) =>
                                                                    handleInputChange(e, index, setActiveResumeList)
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                        <button
                                            type="button"
                                            className="resume__add"
                                            disabled={payload.resumeActiveYn === 'N'}
                                            onClick={handleAddActive}
                                        >
                                            <div className="resume__add-icon" />
                                            추가
                                        </button>
                                    </>
                                )}
                            </div>
                            <div className="resume__tit-box">
                                <h4 className="resume__tit2">
                                    자기소개서<span>*</span>
                                </h4>
                            </div>
                            <div className="resume__textarea-wrap resume__block">
                                <textarea
                                    className="resume__textarea resume__textarea--h590"
                                    placeholder="자기소개, 성격 장단점, 입사 후 포부 등의 내용을 적어주세요."
                                    name="resumeContent"
                                    value={payload.resumeContent || ''}
                                    onChange={handleChange}
                                />
                            </div>
                            <p className="resume__btm-text">
                                위의 모든 내용은 사실과 다름 없음을 확인합니다.
                                <br />
                                이력서 관리 메뉴에서 이력서의 공개 여부를 설정할 수 있습니다.
                            </p>
                            <p className="resume__btm-text">
                                *이력서 공개 여부를 변경하시려면 이 페이지의 맨 상단 부분에서 수정하실 수 있습니다.
                            </p>
                            <div className="resume__btbx">
                                <Link to="/paiab020" className="resume__btn">
                                    취소
                                </Link>
                                <button type="button" className="resume__btn" onClick={submitForm2}>
                                    임시저장
                                </button>
                                <button type="button" className="resume__btn resume__btn--blue" onClick={submitForm}>
                                    저장완료
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PAIAB010;
